import { LOGIN_PROVIDER } from '@toruslabs/openlogin-utils';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { SafeEventEmitter } from '@toruslabs/openlogin-jrpc';
import { log, ADAPTER_STATUS, WALLET_ADAPTERS, ADAPTER_NAMES, ADAPTER_EVENTS, BaseNetworkSwitch } from '@web3auth/base';
import { createRoot } from 'react-dom/client';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import cloneDeep from 'lodash.clonedeep';
import deepmerge from 'lodash.merge';
import { createContext, useEffect, memo, useState, useMemo, useCallback, useContext } from 'react';
import { initReactI18next, useTranslation } from 'react-i18next';
import i18n from 'i18next';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import bowser from 'bowser';
import copyToClipboard from 'copy-to-clipboard';
import { QRCode } from 'react-qrcode-logo';
import { get, post } from '@toruslabs/http-helpers';
import classNames from 'classnames';

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
const OPENLOGIN_PROVIDERS = Object.values(LOGIN_PROVIDER).filter(x => x !== LOGIN_PROVIDER.WEBAUTHN && x !== LOGIN_PROVIDER.JWT);
const OPENLOGIN_PROVIDERS_NAMES = OPENLOGIN_PROVIDERS.reduce((acc, x) => {
  if (x === "email_passwordless") acc[x] = "Email";else if (x === "sms_passwordless") acc[x] = "Mobile";else acc[x] = capitalizeFirstLetter(x);
  return acc;
}, {});

// TODO: change whitelabel settings and pass ui whitelabel to openlogin.
// capture whitelabel only once
const LOGIN_MODAL_EVENTS = {
  INIT_EXTERNAL_WALLETS: "INIT_EXTERNAL_WALLETS",
  LOGIN: "LOGIN",
  DISCONNECT: "DISCONNECT",
  MODAL_VISIBILITY: "MODAL_VISIBILITY"
};
const MODAL_STATUS = {
  INITIALIZED: "initialized",
  CONNECTED: "connected",
  CONNECTING: "connecting",
  ERRORED: "errored"
};
const DEFAULT_LOGO_LIGHT = "https://images.web3auth.io/web3auth-logo-w-light.svg";
const DEFAULT_LOGO_DARK = "https://images.web3auth.io/web3auth-logo-w.svg";
const WALLET_CONNECT_LOGO = "https://images.web3auth.io/login-wallet-connect.svg";

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') {
    return;
  }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$1 = "/*! tailwindcss v3.3.5 | MIT License | https://tailwindcss.com*/.w3a-parent-container *,.w3a-parent-container :after,.w3a-parent-container :before{border:0 solid #e5e7eb;box-sizing:border-box}.w3a-parent-container :after,.w3a-parent-container :before{--tw-content:\"\"}.w3a-parent-container html{-webkit-text-size-adjust:100%;font-feature-settings:normal;font-family:ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;font-variation-settings:normal;line-height:1.5;-moz-tab-size:4;tab-size:4}.w3a-parent-container body{line-height:inherit;margin:0}.w3a-parent-container hr{border-top-width:1px;color:inherit;height:0}.w3a-parent-container abbr:where([title]){text-decoration:underline dotted}.w3a-parent-container h1,.w3a-parent-container h2,.w3a-parent-container h3,.w3a-parent-container h4,.w3a-parent-container h5,.w3a-parent-container h6{font-size:inherit;font-weight:inherit}.w3a-parent-container a{color:inherit;text-decoration:inherit}.w3a-parent-container b,.w3a-parent-container strong{font-weight:bolder}.w3a-parent-container code,.w3a-parent-container kbd,.w3a-parent-container pre,.w3a-parent-container samp{font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;font-size:1em}.w3a-parent-container small{font-size:80%}.w3a-parent-container sub,.w3a-parent-container sup{font-size:75%;line-height:0;position:relative;vertical-align:initial}.w3a-parent-container sub{bottom:-.25em}.w3a-parent-container sup{top:-.5em}.w3a-parent-container table{border-collapse:collapse;border-color:inherit;text-indent:0}.w3a-parent-container button,.w3a-parent-container input,.w3a-parent-container optgroup,.w3a-parent-container select,.w3a-parent-container textarea{font-feature-settings:inherit;color:inherit;font-family:inherit;font-size:100%;font-variation-settings:inherit;font-weight:inherit;line-height:inherit;margin:0;padding:0}.w3a-parent-container button,.w3a-parent-container select{text-transform:none}.w3a-parent-container [type=button],.w3a-parent-container [type=reset],.w3a-parent-container [type=submit],.w3a-parent-container button{-webkit-appearance:button;background-color:initial;background-image:none}.w3a-parent-container :-moz-focusring{outline:auto}.w3a-parent-container :-moz-ui-invalid{box-shadow:none}.w3a-parent-container progress{vertical-align:initial}.w3a-parent-container ::-webkit-inner-spin-button,.w3a-parent-container ::-webkit-outer-spin-button{height:auto}.w3a-parent-container [type=search]{-webkit-appearance:textfield;outline-offset:-2px}.w3a-parent-container ::-webkit-search-decoration{-webkit-appearance:none}.w3a-parent-container ::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}.w3a-parent-container summary{display:list-item}.w3a-parent-container blockquote,.w3a-parent-container dd,.w3a-parent-container dl,.w3a-parent-container figure,.w3a-parent-container h1,.w3a-parent-container h2,.w3a-parent-container h3,.w3a-parent-container h4,.w3a-parent-container h5,.w3a-parent-container h6,.w3a-parent-container hr,.w3a-parent-container p,.w3a-parent-container pre{margin:0}.w3a-parent-container fieldset{margin:0;padding:0}.w3a-parent-container legend{padding:0}.w3a-parent-container menu,.w3a-parent-container ol,.w3a-parent-container ul{list-style:none;margin:0;padding:0}.w3a-parent-container dialog{padding:0}.w3a-parent-container textarea{resize:vertical}.w3a-parent-container input::placeholder,.w3a-parent-container textarea::placeholder{color:#9ca3af;opacity:1}.w3a-parent-container [role=button],.w3a-parent-container button{cursor:pointer}.w3a-parent-container :disabled{cursor:default}.w3a-parent-container audio,.w3a-parent-container canvas,.w3a-parent-container embed,.w3a-parent-container iframe,.w3a-parent-container img,.w3a-parent-container object,.w3a-parent-container svg,.w3a-parent-container video{display:block;vertical-align:middle}.w3a-parent-container img,.w3a-parent-container video{height:auto;max-width:100%}.w3a-parent-container [hidden]{display:none}.w3a-parent-container *,.w3a-parent-container :after,.w3a-parent-container :before{--tw-border-spacing-x:0;--tw-border-spacing-y:0;--tw-translate-x:0;--tw-translate-y:0;--tw-rotate:0;--tw-skew-x:0;--tw-skew-y:0;--tw-scale-x:1;--tw-scale-y:1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness:proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width:0px;--tw-ring-offset-color:#fff;--tw-ring-color:#3b82f680;--tw-ring-offset-shadow:0 0 #0000;--tw-ring-shadow:0 0 #0000;--tw-shadow:0 0 #0000;--tw-shadow-colored:0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: }.w3a-parent-container ::backdrop{--tw-border-spacing-x:0;--tw-border-spacing-y:0;--tw-translate-x:0;--tw-translate-y:0;--tw-rotate:0;--tw-skew-x:0;--tw-skew-y:0;--tw-scale-x:1;--tw-scale-y:1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness:proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width:0px;--tw-ring-offset-color:#fff;--tw-ring-color:#3b82f680;--tw-ring-offset-shadow:0 0 #0000;--tw-ring-shadow:0 0 #0000;--tw-shadow:0 0 #0000;--tw-shadow-colored:0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: }.w3a-parent-container .container{width:100%}@media (min-width:640px){.w3a-parent-container .container{max-width:640px}}@media (min-width:768px){.w3a-parent-container .container{max-width:768px}}@media (min-width:1024px){.w3a-parent-container .container{max-width:1024px}}@media (min-width:1280px){.w3a-parent-container .container{max-width:1280px}}@media (min-width:1536px){.w3a-parent-container .container{max-width:1536px}}.w3a-parent-container .absolute{position:absolute}.w3a-parent-container .relative{position:relative}.w3a-parent-container .top-4{top:1rem}.w3a-parent-container .z-20{z-index:20}.w3a-parent-container .col-span-2{grid-column:span 2/span 2}.w3a-parent-container .col-span-3{grid-column:span 3/span 3}.w3a-parent-container .col-span-6{grid-column:span 6/span 6}.w3a-parent-container .-mb-2{margin-bottom:-.5rem}.w3a-parent-container .-ml-\\[100px\\]{margin-left:-100px}.w3a-parent-container .mb-1{margin-bottom:.25rem}.w3a-parent-container .mb-4{margin-bottom:1rem}.w3a-parent-container .mb-5{margin-bottom:1.25rem}.w3a-parent-container .ml-2{margin-left:.5rem}.w3a-parent-container .ml-\\[3px\\]{margin-left:3px}.w3a-parent-container .mt-4{margin-top:1rem}.w3a-parent-container .block{display:block}.w3a-parent-container .flex{display:flex}.w3a-parent-container .hidden{display:none}.w3a-parent-container .h-12{height:3rem}.w3a-parent-container .h-3{height:.75rem}.w3a-parent-container .w-3{width:.75rem}.w3a-parent-container .w-\\[300px\\]{width:300px}.w3a-parent-container .w-full{width:100%}.w3a-parent-container .rotate-45{--tw-rotate:45deg;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.w3a-parent-container .cursor-pointer{cursor:pointer}.w3a-parent-container .flex-col{flex-direction:column}.w3a-parent-container .items-center{align-items:center}.w3a-parent-container .rounded-md{border-radius:.375rem}.w3a-parent-container .bg-app-gray-50{--tw-bg-opacity:1;background-color:rgb(249 250 251/var(--tw-bg-opacity))}.w3a-parent-container .p-4{padding:1rem}.w3a-parent-container .text-left{text-align:left}.w3a-parent-container .text-right{text-align:right}.w3a-parent-container .text-xs{font-size:.75rem;line-height:1rem}.w3a-parent-container .font-medium{font-weight:500}.w3a-parent-container .leading-none{line-height:1}.w3a-parent-container .text-app-gray-400{--tw-text-opacity:1;color:rgb(156 163 175/var(--tw-text-opacity))}.w3a-parent-container .text-app-gray-900{--tw-text-opacity:1;color:rgb(17 25 40/var(--tw-text-opacity))}.w3a-parent-container .text-white{--tw-text-opacity:1;color:rgb(255 255 255/var(--tw-text-opacity))}.w3a-parent-container .shadow-lg{--tw-shadow:0 10px 15px -3px #0000001a,0 4px 6px -4px #0000001a;--tw-shadow-colored:0 10px 15px -3px var(--tw-shadow-color),0 4px 6px -4px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}.w3a-parent-container .filter{filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}.w3a-parent-container input[type=number]::-webkit-inner-spin-button,.w3a-parent-container input[type=number]::-webkit-outer-spin-button{appearance:none}@font-face{font-display:swap;font-family:Inter;font-style:normal;font-weight:400;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2JL7W0Q5n-wU.woff2) format(\"woff2\");unicode-range:u+0460-052f,u+1c80-1c88,u+20b4,u+2de0-2dff,u+a640-a69f,u+fe2e-fe2f}@font-face{font-display:swap;font-family:Inter;font-style:normal;font-weight:400;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa0ZL7W0Q5n-wU.woff2) format(\"woff2\");unicode-range:u+0301,u+0400-045f,u+0490-0491,u+04b0-04b1,u+2116}@font-face{font-display:swap;font-family:Inter;font-style:normal;font-weight:400;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2ZL7W0Q5n-wU.woff2) format(\"woff2\");unicode-range:u+1f??}@font-face{font-display:swap;font-family:Inter;font-style:normal;font-weight:400;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1pL7W0Q5n-wU.woff2) format(\"woff2\");unicode-range:u+0370-03ff}@font-face{font-display:swap;font-family:Inter;font-style:normal;font-weight:400;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2pL7W0Q5n-wU.woff2) format(\"woff2\");unicode-range:u+0102-0103,u+0110-0111,u+0128-0129,u+0168-0169,u+01a0-01a1,u+01af-01b0,u+1ea0-1ef9,u+20ab}@font-face{font-display:swap;font-family:Inter;font-style:normal;font-weight:400;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa25L7W0Q5n-wU.woff2) format(\"woff2\");unicode-range:u+0100-024f,u+0259,u+1e??,u+2020,u+20a0-20ab,u+20ad-20cf,u+2113,u+2c60-2c7f,u+a720-a7ff}@font-face{font-display:swap;font-family:Inter;font-style:normal;font-weight:400;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7W0Q5nw.woff2) format(\"woff2\");unicode-range:u+00??,u+0131,u+0152-0153,u+02bb-02bc,u+02c6,u+02da,u+02dc,u+2000-206f,u+2074,u+20ac,u+2122,u+2191,u+2193,u+2212,u+2215,u+feff,u+fffd}@font-face{font-display:swap;font-family:Inter;font-style:normal;font-weight:500;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2JL7W0Q5n-wU.woff2) format(\"woff2\");unicode-range:u+0460-052f,u+1c80-1c88,u+20b4,u+2de0-2dff,u+a640-a69f,u+fe2e-fe2f}@font-face{font-display:swap;font-family:Inter;font-style:normal;font-weight:500;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa0ZL7W0Q5n-wU.woff2) format(\"woff2\");unicode-range:u+0301,u+0400-045f,u+0490-0491,u+04b0-04b1,u+2116}@font-face{font-display:swap;font-family:Inter;font-style:normal;font-weight:500;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2ZL7W0Q5n-wU.woff2) format(\"woff2\");unicode-range:u+1f??}@font-face{font-display:swap;font-family:Inter;font-style:normal;font-weight:500;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1pL7W0Q5n-wU.woff2) format(\"woff2\");unicode-range:u+0370-03ff}@font-face{font-display:swap;font-family:Inter;font-style:normal;font-weight:500;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2pL7W0Q5n-wU.woff2) format(\"woff2\");unicode-range:u+0102-0103,u+0110-0111,u+0128-0129,u+0168-0169,u+01a0-01a1,u+01af-01b0,u+1ea0-1ef9,u+20ab}@font-face{font-display:swap;font-family:Inter;font-style:normal;font-weight:500;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa25L7W0Q5n-wU.woff2) format(\"woff2\");unicode-range:u+0100-024f,u+0259,u+1e??,u+2020,u+20a0-20ab,u+20ad-20cf,u+2113,u+2c60-2c7f,u+a720-a7ff}@font-face{font-display:swap;font-family:Inter;font-style:normal;font-weight:500;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7W0Q5nw.woff2) format(\"woff2\");unicode-range:u+00??,u+0131,u+0152-0153,u+02bb-02bc,u+02c6,u+02da,u+02dc,u+2000-206f,u+2074,u+20ac,u+2122,u+2191,u+2193,u+2212,u+2215,u+feff,u+fffd}@font-face{font-display:swap;font-family:Inter;font-style:normal;font-weight:700;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2JL7W0Q5n-wU.woff2) format(\"woff2\");unicode-range:u+0460-052f,u+1c80-1c88,u+20b4,u+2de0-2dff,u+a640-a69f,u+fe2e-fe2f}@font-face{font-display:swap;font-family:Inter;font-style:normal;font-weight:700;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa0ZL7W0Q5n-wU.woff2) format(\"woff2\");unicode-range:u+0301,u+0400-045f,u+0490-0491,u+04b0-04b1,u+2116}@font-face{font-display:swap;font-family:Inter;font-style:normal;font-weight:700;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2ZL7W0Q5n-wU.woff2) format(\"woff2\");unicode-range:u+1f??}@font-face{font-display:swap;font-family:Inter;font-style:normal;font-weight:700;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1pL7W0Q5n-wU.woff2) format(\"woff2\");unicode-range:u+0370-03ff}@font-face{font-display:swap;font-family:Inter;font-style:normal;font-weight:700;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2pL7W0Q5n-wU.woff2) format(\"woff2\");unicode-range:u+0102-0103,u+0110-0111,u+0128-0129,u+0168-0169,u+01a0-01a1,u+01af-01b0,u+1ea0-1ef9,u+20ab}@font-face{font-display:swap;font-family:Inter;font-style:normal;font-weight:700;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa25L7W0Q5n-wU.woff2) format(\"woff2\");unicode-range:u+0100-024f,u+0259,u+1e??,u+2020,u+20a0-20ab,u+20ad-20cf,u+2113,u+2c60-2c7f,u+a720-a7ff}@font-face{font-display:swap;font-family:Inter;font-style:normal;font-weight:700;src:url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7W0Q5nw.woff2) format(\"woff2\");unicode-range:u+00??,u+0131,u+0152-0153,u+02bb-02bc,u+02c6,u+02da,u+02dc,u+2000-206f,u+2074,u+20ac,u+2122,u+2191,u+2193,u+2212,u+2215,u+feff,u+fffd}.w3a-parent-container #w3a-modal{align-items:center;box-sizing:border-box;display:flex;font-family:Inter;inset:0;justify-content:center;padding:1rem;position:fixed}.w3a-parent-container #w3a-modal.w3a-modal--hidden{display:none}.w3a-parent-container #w3a-modal .w3a-modal__inner{--tw-border-opacity:1;--tw-bg-opacity:1;--tw-shadow:0px 4px 16px #00000014;--tw-shadow-colored:0px 4px 16px var(--tw-shadow-color);background-color:rgb(255 255 255/var(--tw-bg-opacity));border-color:rgb(243 244 246/var(--tw-border-opacity));border-radius:32px;border-width:1px;box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow);display:flex;flex-direction:column;max-height:95%;max-width:392px;min-height:630px;opacity:0;overflow-x:hidden;overflow-y:hidden;position:relative;width:100%}.w3a-parent-container :is(.dark #w3a-modal .w3a-modal__inner){--tw-border-opacity:1;--tw-bg-opacity:1;background-color:rgb(55 65 81/var(--tw-bg-opacity));border-color:rgb(55 65 81/var(--tw-border-opacity))}.w3a-parent-container #w3a-modal .w3a-modal__inner{transform:scale(0);transform-origin:center center;transition:all .15s cubic-bezier(.92,0,1,.67)}.w3a-parent-container #w3a-modal .w3a-modal__inner.w3a-modal__inner--active{opacity:1;transform:scale(1);transform-origin:center center;transition:all .15s cubic-bezier(0,.73,.71,1)}.w3a-parent-container #w3a-modal .w3a-modal__header{padding:.5rem 2rem;position:relative}.w3a-parent-container #w3a-modal .w3a-modal__content{overflow-y:auto;padding:1rem 2rem}.w3a-parent-container #w3a-modal .w3a-modal__footer{--tw-bg-opacity:1;align-items:center;background-color:rgb(249 250 251/var(--tw-bg-opacity));justify-content:center;margin-top:auto;padding:1rem 2rem;text-align:center}.w3a-parent-container :is(.dark #w3a-modal .w3a-modal__footer){--tw-bg-opacity:1;background-color:rgb(75 85 99/var(--tw-bg-opacity))}.w3a-parent-container #w3a-modal .w3a-header{align-items:center;display:flex;padding-top:2rem}.w3a-parent-container #w3a-modal .w3a-header__logo{margin-bottom:1rem}.w3a-parent-container #w3a-modal .w3a-header__logo img{height:auto;width:2.5rem}.w3a-parent-container #w3a-modal .w3a-header__title{--tw-text-opacity:1;color:rgb(17 25 40/var(--tw-text-opacity));font-size:1.25rem;font-weight:700;line-height:1.75rem}.w3a-parent-container :is(.dark #w3a-modal .w3a-header__title){--tw-text-opacity:1;color:rgb(255 255 255/var(--tw-text-opacity))}.w3a-parent-container #w3a-modal div.w3a-header__subtitle{--tw-text-opacity:1;align-items:center;color:rgb(107 114 128/var(--tw-text-opacity));display:flex;font-size:.875rem;font-weight:400;line-height:1.25rem}.w3a-parent-container :is(.dark #w3a-modal div.w3a-header__subtitle){--tw-text-opacity:1;color:rgb(156 163 175/var(--tw-text-opacity))}.w3a-parent-container #w3a-modal div.w3a-header__subtitle img{height:14px;margin-left:.25rem;width:14px}.w3a-parent-container #w3a-modal button.w3a-header__button{border-width:0;cursor:pointer;padding:0;position:absolute;right:1.75rem;top:1.25rem}.w3a-parent-container #w3a-modal button.w3a-header__button:active,.w3a-parent-container #w3a-modal button.w3a-header__button:focus{outline-color:#f9fafb}.w3a-parent-container :is(.dark #w3a-modal button.w3a-header__button:focus){outline-color:#9ca3af;outline-style:solid;outline-width:1px}.w3a-parent-container :is(.dark #w3a-modal button.w3a-header__button:active){outline-color:#9ca3af;outline-style:solid;outline-width:1px}.w3a-parent-container #w3a-modal div.w3a-social__policy{--tw-text-opacity:1;color:rgb(107 114 128/var(--tw-text-opacity));font-size:.75rem;font-weight:500;line-height:1rem;margin-top:1rem;text-align:left}.w3a-parent-container :is(.dark #w3a-modal div.w3a-social__policy){--tw-text-opacity:1;color:rgb(156 163 175/var(--tw-text-opacity))}.w3a-parent-container #w3a-modal .w3a-group{margin-bottom:1rem}.w3a-parent-container #w3a-modal .w3a-group:last-child{margin-bottom:0}.w3a-parent-container #w3a-modal .w3ajs-passwordless div.w3a-group__title{align-items:center;display:flex}.w3a-parent-container #w3a-modal .w3ajs-passwordless div.w3a-group__title img{height:14px;margin-left:.25rem;width:14px}.w3a-parent-container #w3a-modal .w3a-group.w3a-group--email-hidden,.w3a-parent-container #w3a-modal .w3a-group.w3a-group--ext-wallet-hidden,.w3a-parent-container #w3a-modal .w3a-group.w3a-group--hidden,.w3a-parent-container #w3a-modal .w3a-group.w3a-group--social-hidden{display:none}.w3a-parent-container #w3a-modal div.w3a-group__title{--tw-text-opacity:1;color:rgb(17 25 40/var(--tw-text-opacity));font-size:.875rem;font-weight:500;line-height:1.25rem;margin-bottom:.5rem}.w3a-parent-container :is(.dark #w3a-modal div.w3a-group__title){--tw-text-opacity:1;color:rgb(255 255 255/var(--tw-text-opacity))}.w3a-parent-container #w3a-modal ul.w3a-adapter-list{column-gap:.5rem;display:grid;grid-template-columns:repeat(6,minmax(0,1fr));max-height:500px;overflow-y:hidden;padding:1px;row-gap:1rem;transition:max-height .35s;transition-timing-function:cubic-bezier(.92,0,.74,1)}.w3a-parent-container #w3a-modal ul.w3a-adapter-list.w3a-adapter-list--shrink{max-height:108px;transition:max-height .3s;transition-timing-function:cubic-bezier(0,.73,.71,1)}.w3a-parent-container #w3a-modal ul.w3a-adapter-list.w3a-adapter-list--hidden{display:none}.w3a-parent-container #w3a-modal li.w3a-adapter-item{list-style-type:none}.w3a-parent-container #w3a-modal li.w3a-adapter-item--full{grid-column:span 6/span 6}.w3a-parent-container #w3a-modal .w3a-adapter-item--hide{display:none}.w3a-parent-container #w3a-modal .w3a-external-toggle{display:block}.w3a-parent-container #w3a-modal .w3a-external-toggle.w3a-external-toggle--hidden{display:none}.w3a-parent-container #w3a-modal .w3a-external-container{display:block;margin-bottom:0}.w3a-parent-container #w3a-modal .w3a-external-container.w3a-external-container--hidden{display:none}.w3a-parent-container #w3a-modal .w3a-external-group{display:flex;flex-wrap:wrap;gap:.75rem;margin-bottom:1rem}.w3a-parent-container #w3a-modal .w3a-external-group__left{flex-grow:1}.w3a-parent-container #w3a-modal button.w3a-external-back{--tw-text-opacity:1;align-items:center;background-image:none;border-width:0;color:rgb(107 114 128/var(--tw-text-opacity));cursor:pointer;display:inline-flex;margin-bottom:.5rem;padding:0}.w3a-parent-container #w3a-modal button.w3a-external-back:active,.w3a-parent-container #w3a-modal button.w3a-external-back:focus{outline-color:#f9fafb}.w3a-parent-container :is(.dark #w3a-modal button.w3a-external-back){--tw-text-opacity:1;color:rgb(156 163 175/var(--tw-text-opacity))}.w3a-parent-container :is(.dark #w3a-modal button.w3a-external-back:focus){outline-color:#9ca3af;outline-style:solid;outline-width:1px}.w3a-parent-container :is(.dark #w3a-modal button.w3a-external-back:active){outline-color:#9ca3af;outline-style:solid;outline-width:1px}.w3a-parent-container #w3a-modal .w3a-external-back .w3a-group__title{--tw-text-opacity:1;color:rgb(156 163 175/var(--tw-text-opacity));margin-bottom:0;margin-left:5px}.w3a-parent-container #w3a-modal .w3a-external-loader{display:flex;justify-content:center}.w3a-parent-container #w3a-modal .w3a-wallet-connect{display:block;margin-bottom:1rem;text-align:center}.w3a-parent-container #w3a-modal .w3a-wallet-connect.w3a-wallet-connect--hidden{display:none}.w3a-parent-container #w3a-modal .w3a-wallet-connect__container{--tw-bg-opacity:1;--tw-text-opacity:1;background-color:rgb(255 255 255/var(--tw-bg-opacity));border-radius:10px;color:rgb(107 114 128/var(--tw-text-opacity));font-size:.625rem;margin-left:auto;margin-right:auto;min-width:250px;padding:1rem .75rem;width:fit-content}.w3a-parent-container :is(.dark #w3a-modal .w3a-wallet-connect__container){--tw-text-opacity:1;color:rgb(156 163 175/var(--tw-text-opacity))}.w3a-parent-container #w3a-modal .w3a-wallet-connect__container-android,.w3a-parent-container #w3a-modal .w3a-wallet-connect__container-desktop{margin:auto}.w3a-parent-container #w3a-modal .w3a-wallet-connect__container-btn-group{display:flex;gap:18px}.w3a-parent-container #w3a-modal .w3a-wallet-connect__container-ios{box-sizing:border-box;column-gap:1.25rem;display:flex;flex-wrap:wrap;padding:0 0 1.75rem;row-gap:30px}.w3a-parent-container #w3a-modal .w3a-wallet-connect-qr{margin:1rem}.w3a-parent-container #w3a-modal .w3a-wallet-connect-qr>canvas,.w3a-parent-container #w3a-modal .w3a-wallet-connect-qr>svg{margin:auto}.w3a-parent-container #w3a-modal .w3a-wallet-connect__container-android a{text-decoration-line:none}.w3a-parent-container #w3a-modal .w3a-wallet-connect__logo>img{margin:0 auto 1rem;width:115px}.w3a-parent-container #w3a-modal .w3a-footer{--tw-text-opacity:1;align-items:center;color:rgb(156 163 175/var(--tw-text-opacity));display:flex;font-size:.75rem;justify-content:center;line-height:1rem}.w3a-parent-container #w3a-modal .w3a-footer__links a:active,.w3a-parent-container #w3a-modal .w3a-footer__links a:focus{outline-color:#f9fafb}.w3a-parent-container :is(.dark #w3a-modal .w3a-footer__links a:focus){outline-color:#9ca3af;outline-style:solid;outline-width:1px}.w3a-parent-container :is(.dark #w3a-modal .w3a-footer__links a:active){outline-color:#9ca3af;outline-style:solid;outline-width:1px}.w3a-parent-container #w3a-modal .w3a-footer__links span{margin:0 4px}.w3a-parent-container #w3a-modal.w3a-modal--light .w3a-footer__links a:focus-visible{outline:1px solid #0f1222}.w3a-parent-container #w3a-modal.w3a-modal--light .w3a-external-back:focus-visible{outline:1px solid #0f1222}.w3a-parent-container .hover-icon{display:none;transition:display .15s;transition-timing-function:cubic-bezier(0,.54,.63,.99)}.w3a-parent-container #w3a-modal .w3a-text-field{--tw-border-opacity:1;--tw-bg-opacity:1;--tw-text-opacity:1;background-color:rgb(249 250 251/var(--tw-bg-opacity));border-color:rgb(209 213 219/var(--tw-border-opacity));border-radius:9999px;border-width:1px;color:rgb(17 25 40/var(--tw-text-opacity));font-size:.875rem;line-height:1.25rem;margin-top:.5rem;padding:.75rem 1.5rem}.w3a-parent-container #w3a-modal .w3a-text-field::placeholder{--tw-placeholder-opacity:1;color:rgb(107 114 128/var(--tw-placeholder-opacity))}.w3a-parent-container #w3a-modal .w3a-text-field{--tw-ring-offset-shadow:var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow:var(--tw-ring-inset) 0 0 0 calc(var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow,0 0 #0000);outline-width:0}.w3a-parent-container #w3a-modal .w3a-text-field:focus{--tw-ring-offset-shadow:var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow:var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);--tw-ring-opacity:1;--tw-ring-color:rgb(3 100 255/var(--tw-ring-opacity));border-color:#0000;box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow,0 0 #0000)}.w3a-parent-container #w3a-modal .w3a-text-field:disabled{cursor:not-allowed}.w3a-parent-container #w3a-modal .w3a-text-field:disabled::placeholder{--tw-placeholder-opacity:1;color:rgb(156 163 175/var(--tw-placeholder-opacity))}.w3a-parent-container :is(.dark #w3a-modal .w3a-text-field){--tw-border-opacity:1;--tw-bg-opacity:1;--tw-text-opacity:1;background-color:rgb(75 85 99/var(--tw-bg-opacity));border-color:rgb(107 114 128/var(--tw-border-opacity));color:rgb(255 255 255/var(--tw-text-opacity))}.w3a-parent-container :is(.dark #w3a-modal .w3a-text-field)::placeholder{--tw-placeholder-opacity:1;color:rgb(156 163 175/var(--tw-placeholder-opacity))}.w3a-parent-container :is(.dark #w3a-modal .w3a-text-field:focus){--tw-ring-opacity:1;--tw-ring-color:rgb(3 100 255/var(--tw-ring-opacity));border-color:#0000}.w3a-parent-container :is(.dark #w3a-modal .w3a-text-field:disabled)::placeholder{--tw-placeholder-opacity:1;color:rgb(107 114 128/var(--tw-placeholder-opacity))}.w3a-parent-container #w3a-modal .w3a-text-field{line-height:1.25em}.w3a-parent-container #w3a-modal .w3a-text-field--country-code{display:flex;justify-content:space-between;padding-left:1rem;padding-right:1rem;width:100%}.w3a-parent-container #w3a-modal .w3a-text-field--number{appearance:none}.w3a-parent-container #w3a-modal .w3a-sms-field--error{--tw-text-opacity:1;color:rgb(239 68 68/var(--tw-text-opacity));font-size:.875rem;line-height:1.25rem;margin-bottom:.5rem;margin-left:.375rem;margin-top:-.5rem}.w3a-parent-container #w3a-container #w3a-modal input.w3a-text-field:-webkit-autofill,.w3a-parent-container #w3a-container #w3a-modal input.w3a-text-field:-webkit-autofill:active,.w3a-parent-container #w3a-container #w3a-modal input.w3a-text-field:-webkit-autofill:focus,.w3a-parent-container #w3a-container #w3a-modal input.w3a-text-field:-webkit-autofill:hover{--tw-shadow:0 0 0 30px #f9fafb inset;--tw-shadow-colored:inset 0 0 0 30px var(--tw-shadow-color);-webkit-text-fill-color:#111928!important;box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}.w3a-parent-container #w3a-container.dark #w3a-modal input.w3a-text-field:-webkit-autofill,.w3a-parent-container #w3a-container.dark #w3a-modal input.w3a-text-field:-webkit-autofill:active,.w3a-parent-container #w3a-container.dark #w3a-modal input.w3a-text-field:-webkit-autofill:focus,.w3a-parent-container #w3a-container.dark #w3a-modal input.w3a-text-field:-webkit-autofill:hover{--tw-shadow:0 0 0 30px #374151 inset;--tw-shadow-colored:inset 0 0 0 30px var(--tw-shadow-color);-webkit-text-fill-color:#fff!important;box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}.w3a-parent-container #w3a-modal .w3a-button{--tw-bg-opacity:1;--tw-text-opacity:1;background-color:rgb(243 244 246/var(--tw-bg-opacity));border-radius:9999px;color:rgb(17 25 40/var(--tw-text-opacity));font-size:1rem;font-weight:500;line-height:1.5rem;padding:.75rem 1.5rem}.w3a-parent-container #w3a-modal .w3a-button:hover{--tw-bg-opacity:1;background-color:rgb(209 213 219/var(--tw-bg-opacity))}.w3a-parent-container #w3a-modal .w3a-button:focus{--tw-bg-opacity:1;--tw-text-opacity:1;background-color:rgb(243 244 246/var(--tw-bg-opacity));color:rgb(55 65 81/var(--tw-text-opacity));outline-color:#f9fafb}.w3a-parent-container #w3a-modal .w3a-button:active{outline-color:#f9fafb}.w3a-parent-container #w3a-modal .w3a-button:disabled{--tw-bg-opacity:1;--tw-text-opacity:1;background-color:rgb(249 250 251/var(--tw-bg-opacity));color:rgb(209 213 219/var(--tw-text-opacity))}.w3a-parent-container :is(.dark #w3a-modal .w3a-button){--tw-bg-opacity:1;--tw-text-opacity:1;background-color:rgb(17 25 40/var(--tw-bg-opacity));color:rgb(255 255 255/var(--tw-text-opacity))}.w3a-parent-container :is(.dark #w3a-modal .w3a-button:hover){--tw-bg-opacity:1;background-color:rgb(31 42 55/var(--tw-bg-opacity))}.w3a-parent-container :is(.dark #w3a-modal .w3a-button:focus){--tw-bg-opacity:1;--tw-text-opacity:1;background-color:rgb(17 25 40/var(--tw-bg-opacity));color:rgb(255 255 255/var(--tw-text-opacity));outline-color:#9ca3af;outline-style:solid;outline-width:1px}.w3a-parent-container :is(.dark #w3a-modal .w3a-button:active){outline-color:#9ca3af;outline-style:solid;outline-width:1px}.w3a-parent-container :is(.dark #w3a-modal .w3a-button:disabled){--tw-bg-opacity:1;--tw-text-opacity:1;background-color:rgb(59 69 85/var(--tw-bg-opacity));color:rgb(107 114 128/var(--tw-text-opacity))}.w3a-parent-container #w3a-modal .w3a-button--primary{--tw-bg-opacity:1;--tw-text-opacity:1;background-color:rgb(3 100 255/var(--tw-bg-opacity));color:rgb(255 255 255/var(--tw-text-opacity))}.w3a-parent-container #w3a-modal .w3a-button--primary:hover{--tw-bg-opacity:1;background-color:rgb(30 66 159/var(--tw-bg-opacity))}.w3a-parent-container #w3a-modal .w3a-button--primary:focus{--tw-bg-opacity:1;--tw-text-opacity:1;background-color:rgb(3 100 255/var(--tw-bg-opacity));color:rgb(255 255 255/var(--tw-text-opacity));outline-color:#a4cafe}.w3a-parent-container #w3a-modal .w3a-button--primary:active{outline-color:#a4cafe}.w3a-parent-container #w3a-modal .w3a-button--primary:disabled{--tw-bg-opacity:1;--tw-text-opacity:1;background-color:rgb(195 221 253/var(--tw-bg-opacity));color:rgb(235 245 255/var(--tw-text-opacity))}.w3a-parent-container :is(.dark #w3a-modal .w3a-button--primary){--tw-bg-opacity:1;background-color:rgb(3 100 255/var(--tw-bg-opacity))}.w3a-parent-container :is(.dark #w3a-modal .w3a-button--primary:hover){--tw-bg-opacity:1;background-color:rgb(30 66 159/var(--tw-bg-opacity))}.w3a-parent-container :is(.dark #w3a-modal .w3a-button--primary:focus){--tw-bg-opacity:1;background-color:rgb(3 100 255/var(--tw-bg-opacity))}.w3a-parent-container :is(.dark #w3a-modal .w3a-button--primary:disabled){--tw-bg-opacity:1;--tw-text-opacity:1;background-color:rgb(45 72 116/var(--tw-bg-opacity));color:rgb(107 114 128/var(--tw-text-opacity))}.w3a-parent-container #w3a-modal .w3a-button--login{align-items:center;display:inline-flex;height:2.75rem;justify-content:center}.w3a-parent-container #w3a-modal button.w3a-button--login:hover>.hover-icon{display:block;transition:display .15s;transition-timing-function:cubic-bezier(0,.54,.63,.99)}.w3a-parent-container #w3a-modal button.w3a-button--login:hover>.image-icon{display:none;transition:display .15s;transition-timing-function:cubic-bezier(0,.54,.63,.99)}.w3a-parent-container #w3a-modal button.w3a-button-expand{--tw-text-opacity:1;color:rgb(3 100 255/var(--tw-text-opacity));font-size:.875rem;height:auto;line-height:1.25rem;margin-left:auto;margin-top:1rem;width:auto}.w3a-parent-container #w3a-modal button.w3a-button-expand:hover{--tw-text-opacity:1;color:rgb(30 66 159/var(--tw-text-opacity))}.w3a-parent-container #w3a-modal button.w3a-button-expand:focus-visible{outline-color:#f9fafb;outline-style:solid;outline-width:1px}.w3a-parent-container :is(.dark #w3a-modal button.w3a-button-expand:hover){--tw-text-opacity:1;color:rgb(63 131 248/var(--tw-text-opacity))}.w3a-parent-container :is(.dark #w3a-modal button.w3a-button-expand:focus-visible){outline-color:#9ca3af;outline-style:solid;outline-width:1px}.w3a-parent-container #w3a-modal .w3a-sms-field__container{display:grid;gap:.5rem;grid-template-columns:repeat(12,minmax(0,1fr))}.w3a-parent-container #w3a-modal .w3a-sms-field__code-selected{display:flex}.w3a-parent-container #w3a-modal .w3a-sms-field__code-dropdown{height:185px;position:absolute;width:120px;z-index:10}.w3a-parent-container #w3a-modal .w3a-sms-field__code-dropdown>:not([hidden])~:not([hidden]){--tw-divide-y-reverse:0;--tw-divide-opacity:1;border-bottom-width:calc(1px*var(--tw-divide-y-reverse));border-color:rgb(243 244 246/var(--tw-divide-opacity));border-top-width:calc(1px*(1 - var(--tw-divide-y-reverse)))}.w3a-parent-container #w3a-modal .w3a-sms-field__code-dropdown{--tw-bg-opacity:1;--tw-shadow:0px 4px 16px #00000014;--tw-shadow-colored:0px 4px 16px var(--tw-shadow-color);background-color:rgb(255 255 255/var(--tw-bg-opacity));border-radius:.5rem;box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow);overflow-y:scroll}.w3a-parent-container :is(.dark #w3a-modal .w3a-sms-field__code-dropdown){--tw-bg-opacity:1;background-color:rgb(55 65 81/var(--tw-bg-opacity))}.w3a-parent-container #w3a-modal .w3a-sms-field__code-dropdown{transform:translateY(-230px)}.w3a-parent-container #w3a-modal .w3a-sms-field__code-dropdown--hidden{display:none}.w3a-parent-container #w3a-modal .w3a-sms-field__code-dropdown ul{--tw-text-opacity:1;color:rgb(55 65 81/var(--tw-text-opacity));font-size:.875rem;line-height:1.25rem;padding-bottom:.5rem;padding-top:.5rem}.w3a-parent-container :is(.dark #w3a-modal .w3a-sms-field__code-dropdown ul){--tw-text-opacity:1;color:rgb(229 231 235/var(--tw-text-opacity))}.w3a-parent-container #w3a-modal .w3a-sms-field__code-dropdown li{cursor:pointer;padding:0}.w3a-parent-container #w3a-modal .w3a-sms-field__code-dropdown li:hover{--tw-bg-opacity:1;background-color:rgb(243 244 246/var(--tw-bg-opacity))}.w3a-parent-container :is(.dark #w3a-modal .w3a-sms-field__code-dropdown li:hover){--tw-bg-opacity:1;--tw-text-opacity:1;background-color:rgb(17 24 39/var(--tw-bg-opacity));color:rgb(255 255 255/var(--tw-text-opacity))}.w3a-parent-container #w3a-modal .w3a-sms-field__code-dropdown li button{height:100%;padding:.5rem 1rem;text-align:left;width:100%}.w3a-parent-container #w3a-modal .w3a-sms-field__code-dropdown li button div{align-items:center;display:flex}.w3a-parent-container #w3a-modal .w3a-sms-field__code{grid-column:span 5/span 5}.w3a-parent-container #w3a-modal .w3a-sms-field__number{grid-column:span 7/span 7}.w3a-parent-container #w3a-modal .w3a-modal__loader{--tw-bg-opacity:1;background-color:rgb(255 255 255/var(--tw-bg-opacity));display:flex;inset:0;justify-content:center;position:absolute;z-index:10}.w3a-parent-container :is(.dark #w3a-modal .w3a-modal__loader){--tw-bg-opacity:1;background-color:rgb(55 65 81/var(--tw-bg-opacity))}.w3a-parent-container #w3a-modal .w3a-modal__loader.w3a-modal__loader--hidden{display:none}.w3a-parent-container #w3a-modal .w3a-modal__loader-content{display:flex;flex-direction:column;margin-bottom:50px;position:relative;text-align:center}.w3a-parent-container #w3a-modal .w3a-modal__loader-info{align-items:center;display:flex;flex-direction:column;flex-grow:1;justify-content:center;padding:0 30px}.w3a-parent-container #w3a-modal .w3a-spinner-label{--tw-text-opacity:1;color:rgb(3 100 255/var(--tw-text-opacity));font-size:1rem;font-weight:500;line-height:1.5rem;margin-top:10px}.w3a-parent-container #w3a-modal .w3a-spinner-message{--tw-text-opacity:1;color:rgb(107 114 128/var(--tw-text-opacity));font-size:1rem;line-height:1.5rem;margin-top:10px}.w3a-parent-container #w3a-modal .w3a-spinner-message:first-letter{text-transform:capitalize}.w3a-parent-container :is(.dark #w3a-modal .w3a-spinner-message){--tw-text-opacity:1;color:rgb(255 255 255/var(--tw-text-opacity))}.w3a-parent-container #w3a-modal .w3a-spinner-message.w3a-spinner-message--error{--tw-text-opacity:1;color:rgb(239 68 68/var(--tw-text-opacity))}.w3a-parent-container #w3a-modal .w3a-spinner-power{--tw-text-opacity:1;color:rgb(183 184 189/var(--tw-text-opacity));font-size:.75rem;line-height:1rem;margin-top:auto}.w3a-parent-container #w3a-modal .w3a-spinner-power>img{display:inline;height:2rem;width:auto}.w3a-parent-container #w3a-modal .w3a-spinner{--tw-bg-opacity:1;animation:rotate 1s linear infinite;background-color:rgb(3 100 255/var(--tw-bg-opacity));background:conic-gradient(#0000,#0364ff);border-radius:50%;display:inline-block;height:60px;position:relative;width:60px}.w3a-parent-container #w3a-modal .w3a-spinner__head,.w3a-parent-container #w3a-modal .w3a-spinner__mask{border-radius:100%;content:\"\";position:absolute}.w3a-parent-container #w3a-modal .w3a-spinner__mask{--tw-bg-opacity:1;background-color:rgb(255 255 255/var(--tw-bg-opacity))}.w3a-parent-container :is(.dark #w3a-modal .w3a-spinner__mask){--tw-bg-opacity:1;background-color:rgb(55 65 81/var(--tw-bg-opacity))}.w3a-parent-container #w3a-modal .w3a-spinner__mask{height:50px;left:5px;top:5px;width:50px}.w3a-parent-container #w3a-modal .w3a-spinner__head{--tw-bg-opacity:1;background-color:rgb(3 100 255/var(--tw-bg-opacity));height:5px;left:26px;top:0;width:5px}@keyframes rotate{0%{transform:rotate(0)}to{transform:rotate(1turn)}}.w3a-parent-container #w3a-modal .w3a-modal__loader-bridge{align-items:center;display:flex;justify-content:center;margin-bottom:14px}.w3a-parent-container #w3a-modal .w3a-modal__loader-bridge-message{--tw-text-opacity:1;color:rgb(107 114 128/var(--tw-text-opacity))}.w3a-parent-container #w3a-modal .w3a-modal__loader-bridge-message:first-letter{text-transform:capitalize}.w3a-parent-container :is(.dark #w3a-modal .w3a-modal__loader-bridge-message){--tw-text-opacity:1;color:rgb(255 255 255/var(--tw-text-opacity))}.w3a-parent-container #w3a-modal .w3a-modal__loader-app-logo{display:flex;padding:.5rem}.w3a-parent-container #w3a-modal .w3a-modal__loader-app-logo--default{--tw-bg-opacity:1;align-items:center;background-color:rgb(3 100 255/var(--tw-bg-opacity));border-radius:9999px;height:72px;justify-content:center;width:72px}.w3a-parent-container :is(.dark #w3a-modal .w3a-modal__loader-app-logo--default){--tw-bg-opacity:1;background-color:rgb(249 250 251/var(--tw-bg-opacity))}.w3a-parent-container #w3a-modal .w3a-modal__loader-app-logo img{height:auto;max-height:72px;max-width:72px;width:72px}.w3a-parent-container #w3a-modal .w3a-modal__loader-app-logo--default img{max-height:45px;max-width:45px;width:45px}.w3a-parent-container #w3a-modal .w3a-modal__loader-social-logo{--tw-bg-opacity:1;align-items:center;background-color:rgb(243 244 246/var(--tw-bg-opacity));border-radius:9999px;display:flex;height:72px;justify-content:center;width:72px}.w3a-parent-container :is(.dark #w3a-modal .w3a-modal__loader-social-logo){--tw-bg-opacity:1;background-color:rgb(249 250 251/var(--tw-bg-opacity))}.w3a-parent-container #w3a-modal .w3a-modal__loader-social-logo img{height:4rem;width:4rem}.w3a-parent-container #w3a-modal .w3a-modal__loader-adapter img{height:auto;width:84px}.w3a-parent-container #w3a-modal .w3a-modal__connector{align-items:center;display:flex}.w3a-parent-container .w3a-modal__connector-beat{display:inline-block;height:80px;position:relative;width:80px}.w3a-parent-container .w3a-modal__connector-beat div{animation-timing-function:cubic-bezier(0,1,1,0);background:grey;border-radius:50%;height:13px;position:absolute;top:33px;width:13px}.w3a-parent-container .w3a-modal__connector-beat div:first-child{animation:beat1 2.4s infinite;left:8px}.w3a-parent-container .w3a-modal__connector-beat div:nth-child(2){animation:beat2 2.4s infinite;left:8px}.w3a-parent-container .w3a-modal__connector-beat div:nth-child(3){animation:beat3 2.4s infinite;left:8px}.w3a-parent-container .w3a-modal__connector-beat div:nth-child(4){animation:beat4 2.4s infinite;left:32px}.w3a-parent-container .w3a-modal__connector-beat div:nth-child(5){animation:beat5 2.4s infinite;left:56px}@keyframes beat1{0%{transform:scale(0)}25%{transform:scale(0)}50%{transform:scale(1)}75%{transform:scale(0)}to{transform:scale(0)}}@keyframes beat2{0%{transform:scale(0)}25%{transform:scale(1)}50%{transform:translate(24px)}75%{transform:translate(0)}to{transform:translate(0) scale(0)}}@keyframes beat3{0%{transform:translate(0)}25%{transform:translate(24px)}50%{transform:translate(48px)}75%{transform:translate(24px)}to{transform:translate(0)}}@keyframes beat4{0%{transform:translate(0)}25%{transform:translate(24px)}50%{transform:translate(24px) scale(0)}75%{transform:translate(24px) scale(1)}to{transform:translate(0)}}@keyframes beat5{0%{transform:scale(1)}25%{transform:scale(0)}50%{transform:scale(0)}75%{transform:scale(0)}to{transform:scale(1)}}.w3a-parent-container .group:hover .group-hover\\:flex{display:flex}.w3a-parent-container :is(.dark .dark\\:bg-app-gray-600){--tw-bg-opacity:1;background-color:rgb(75 85 99/var(--tw-bg-opacity))}.w3a-parent-container :is(.dark .dark\\:text-white){--tw-text-opacity:1;color:rgb(255 255 255/var(--tw-text-opacity))}";
styleInject(css_248z$1);

const ThemedContext = /*#__PURE__*/createContext({
  isDark: true // default value
});

var modal = {
  "adapter-loader.message": "Verify your {{adapter}} account to continue",
  "adapter-loader.message1": "Verify your {{adapter}}",
  "adapter-loader.message2": "account to continue",
  "errors-invalid-number-email": "Invalid Email or Phone Number",
  "errors-required": "Required",
  "external.back": "Back",
  "external.connect": "Connect with Wallet",
  "external.title": "External Wallet",
  "external.walletconnect-connect": "Connect",
  "external.walletconnect-copy": "Click on the QR Code to copy to clipboard",
  "external.walletconnect-subtitle": "Scan the QR code with a WalletConnect-compatible wallet",
  "footer.message": "Self-custodial login by",
  "footer.message-new": "Self-custodial login by Web3Auth",
  "footer.policy": "Privacy Policy",
  "footer.terms": "Terms of Use",
  "footer.terms-service": "Terms of Service",
  "footer.version": "Version",
  "header-subtitle": "Select one of the following options to continue",
  "header-subtitle-name": "Your {{appName}} wallet with one click",
  "header-subtitle-new": "Your blockchain wallet with one click",
  "header-title": "Sign in",
  "header-tooltip-desc": "The wallet serves as an account to store and manage your digital assets on the blockchain.",
  "header-tooltip-title": "Wallet",
  "network.add-request": "This site is requesting to add a network",
  "network.cancel": "Cancel",
  "network.from": "From",
  "network.proceed": "Proceed",
  "network.switch-request": "This site is requesting to switch networks",
  "network.to": "To",
  "popup.phone-body": "Your country code will be detected automatically, but if you're using a phone number from a different country, you'll need to enter the correct country code manually.",
  "popup.phone-header": "Phone number and country code",
  "social.continue": "Continue with",
  "social.continueCustom": "Continue with {{adapter}}",
  "social.email": "Email",
  "social.email-continue": "Continue with Email",
  "social.email-new": "name@example.com",
  "social.passwordless-cta": "Continue",
  "social.passwordless-title": "Email or Phone",
  "social.phone": "Phone",
  "social.policy": "We do not store any data related to your social logins.",
  "social.sms": "Mobile",
  "social.sms-continue": "Continue with Mobile",
  "social.sms-invalid-number": "Invalid phone number",
  "social.sms-placeholder-text": "E.g.:",
  "social.view-less": "View fewer options",
  "social.view-less-new": "View fewer",
  "social.view-more": "View more options",
  "social.view-more-new": "View more",
  "post-loading.connected": "You are connected with your account",
  "post-loading.something-wrong": "Something went wrong!"
};
var en = {
  modal: modal
};

const i18nInstance = i18n.createInstance();
i18nInstance.use(initReactI18next).init({
  resources: {
    en: {
      translation: en
    }
  },
  lng: "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false
  },
  debug: false,
  react: {
    useSuspense: true
  }
});

var CircleArrowLeft = "data:image/svg+xml,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20id%3D%2224%20%2F%20arrows%20%2F%20circle-arrow-left%22%3E%3Cpath%20id%3D%22icon%22%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M12%2023C5.92487%2023%201%2018.0751%201%2012C1%205.92487%205.92487%201%2012%201C18.0751%201%2023%205.92487%2023%2012C23%2018.0751%2018.0751%2023%2012%2023ZM12%2021C16.9706%2021%2021%2016.9706%2021%2012C21%207.02944%2016.9706%203%2012%203C7.02944%203%203%207.02944%203%2012C3%2016.9706%207.02944%2021%2012%2021ZM17%2011H10.4142L12.7071%208.70711L11.2929%207.29289L6.58579%2012L11.2929%2016.7071L12.7071%2015.2929L10.4142%2013H17V11Z%22%20fill%3D%22%23D3D3D4%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E";

var Close = "data:image/svg+xml,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M13.4142%2012L19.7782%2018.364L18.364%2019.7782L12%2013.4143L5.63604%2019.7782L4.22183%2018.364L10.5858%2012L4.22183%205.63608L5.63604%204.22187L12%2010.5858L18.364%204.22187L19.7782%205.63608L13.4142%2012Z%22%20fill%3D%22%23DFDFDF%22%2F%3E%3C%2Fsvg%3E";

var Connected = "data:image/svg+xml,%3Csvg%20width%3D%22141%22%20height%3D%22107%22%20viewBox%3D%220%200%20141%20107%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M22.5276%2083.0535C22.5745%2083.0354%2022.613%2082.9958%2022.6292%2082.9402C22.6821%2082.7569%2022.6159%2082.1413%2022.4252%2081.0511C23.204%2080.5866%2023.6245%2080.2954%2023.7147%2080.1668C23.7483%2080.1143%2023.7517%2080.0538%2023.7224%2080.0059C23.6705%2079.9274%2023.6072%2079.8336%2022.0991%2080.112C20.9422%2078.3357%2020.7713%2078.3673%2020.6693%2078.3822C20.66%2078.3858%2020.6489%2078.3852%2020.6349%2078.3906C20.5881%2078.4087%2020.5495%2078.4483%2020.5334%2078.5039C20.4744%2078.6994%2020.5567%2079.4123%2020.7783%2080.6237C19.4856%2081.4304%2019.502%2081.5424%2019.5165%2081.6354C19.5224%2081.6923%2019.5658%2081.7347%2019.6306%2081.7491C19.7839%2081.7834%2020.2955%2081.7134%2021.1934%2081.5284C22.2344%2083.103%2022.3865%2083.0786%2022.4915%2083.0576C22.5072%2083.0565%2022.5183%2083.0571%2022.5276%2083.0535Z%22%20fill%3D%22%239D4492%22%2F%3E%3Cpath%20d%3D%22M38.1699%2024.3125L36.5906%2023.6967L34.7166%2027.4815L36.2959%2028.0974L38.1699%2024.3125Z%22%20fill%3D%22%239BEC7D%22%2F%3E%3Cpath%20d%3D%22M48.5645%2034.7988L49.9232%2035.2505L51.3245%2032.0124L49.9658%2031.5607L48.5645%2034.7988Z%22%20fill%3D%22%23FFBF19%22%2F%3E%3Cpath%20d%3D%22M34.4449%2075.5265L33.4902%2076.6264L36.2729%2078.6922L37.2275%2077.5924L34.4449%2075.5265Z%22%20fill%3D%22%23FFBF19%22%2F%3E%3Cpath%20d%3D%22M35.969%2054.562L35.5664%2056.1768L39.8078%2056.8795L40.2104%2055.2647L35.969%2054.562Z%22%20fill%3D%22%239D4492%22%2F%3E%3Cpath%20d%3D%22M38.1949%2089.7319L37.135%2091.092L40.6027%2093.371L41.6626%2092.0109L38.1949%2089.7319Z%22%20fill%3D%22%239D4492%22%2F%3E%3Cpath%20d%3D%22M35.664%2043.2933L36.2599%2041.7217L32.1621%2040.5607L31.5662%2042.1323L35.664%2043.2933Z%22%20fill%3D%22%239BEC7D%22%2F%3E%3Cpath%20d%3D%22M65.9671%209.19276C65.9998%209.18006%2066.023%209.15631%2066.0317%209.12332C66.0671%209.00603%2066.1432%208.66753%2066.0171%207.96665C66.5192%207.66361%2066.6733%207.41471%2066.733%207.3324C66.7575%207.29825%2066.7582%207.2585%2066.7356%207.22781C66.6999%207.1775%2066.6827%206.98733%2065.706%207.16352C64.9602%206.0171%2064.827%206.16686%2064.7612%206.17758C64.7565%206.1794%2064.7471%206.18303%2064.7424%206.18484C64.7097%206.19754%2064.6865%206.2213%2064.6778%206.25429C64.641%206.38196%2064.5887%206.75785%2064.7307%207.54138C63.8979%208.06133%2064.0099%208.21478%2064.0221%208.27417C64.026%208.31211%2064.0534%208.34097%2064.0945%208.34972C64.194%208.37033%2064.4345%208.4035%2065.019%208.28554C65.6929%209.30198%2065.8761%209.20827%2065.9467%209.19573C65.9513%209.19392%2065.9624%209.19458%2065.9671%209.19276Z%22%20fill%3D%22%239BEC7D%22%2F%3E%3Cpath%20d%3D%22M88.1272%2023.1029C88.16%2023.0902%2088.1831%2023.0665%2088.1919%2023.0335C88.2272%2022.9162%2088.3034%2022.5777%2088.1773%2021.8768C88.6794%2021.5738%2088.8335%2021.3249%2088.8932%2021.2426C88.9176%2021.2084%2088.9184%2021.1687%2088.8957%2021.138C88.8601%2021.0877%2088.8429%2020.8975%2087.8661%2021.0737C87.1203%2019.9273%2086.9872%2020.077%2086.9213%2020.0877C86.9166%2020.0896%2086.9073%2020.0932%2086.9026%2020.095C86.8698%2020.1077%2086.8467%2020.1315%2086.8379%2020.1644C86.8012%2020.2921%2086.7489%2020.668%2086.8908%2021.4515C86.0581%2021.9715%2086.17%2022.1249%2086.1823%2022.1843C86.1862%2022.2223%2086.2135%2022.2511%2086.2546%2022.2599C86.3542%2022.2805%2086.5946%2022.3137%2087.1792%2022.1957C87.8531%2023.2121%2088.0363%2023.1184%2088.1068%2023.1059C88.1115%2023.1041%2088.1225%2023.1047%2088.1272%2023.1029Z%22%20fill%3D%22%23FFBF19%22%2F%3E%3Cpath%20d%3D%22M106.127%2076.1029C106.16%2076.0902%20106.183%2076.0665%20106.192%2076.0335C106.227%2075.9162%20106.303%2075.5777%20106.177%2074.8768C106.679%2074.5738%20106.833%2074.3249%20106.893%2074.2426C106.918%2074.2084%20106.918%2074.1687%20106.896%2074.138C106.86%2074.0877%20106.843%2073.8975%20105.866%2074.0737C105.12%2072.9273%20104.987%2073.077%20104.921%2073.0877C104.917%2073.0896%20104.907%2073.0932%20104.903%2073.095C104.87%2073.1077%20104.847%2073.1315%20104.838%2073.1644C104.801%2073.2921%20104.749%2073.668%20104.891%2074.4515C104.058%2074.9715%20104.17%2075.1249%20104.182%2075.1843C104.186%2075.2223%20104.214%2075.2511%20104.255%2075.2599C104.354%2075.2805%20104.595%2075.3137%20105.179%2075.1957C105.853%2076.2121%20106.036%2076.1184%20106.107%2076.1059C106.111%2076.1041%20106.123%2076.1047%20106.127%2076.1029Z%22%20fill%3D%22%23FFBF19%22%2F%3E%3Cpath%20d%3D%22M28.1272%2065.1029C28.16%2065.0902%2028.1831%2065.0665%2028.1919%2065.0335C28.2272%2064.9162%2028.3034%2064.5777%2028.1773%2063.8768C28.6794%2063.5738%2028.8335%2063.3249%2028.8932%2063.2426C28.9176%2063.2084%2028.9184%2063.1687%2028.8957%2063.138C28.8601%2063.0877%2028.8429%2062.8975%2027.8661%2063.0737C27.1203%2061.9273%2026.9872%2062.077%2026.9213%2062.0877C26.9166%2062.0896%2026.9073%2062.0932%2026.9026%2062.095C26.8698%2062.1077%2026.8467%2062.1315%2026.8379%2062.1644C26.8012%2062.2921%2026.7489%2062.668%2026.8908%2063.4515C26.0581%2063.9715%2026.17%2064.1249%2026.1823%2064.1843C26.1862%2064.2223%2026.2135%2064.2511%2026.2546%2064.2599C26.3542%2064.2805%2026.5946%2064.3137%2027.1792%2064.1957C27.8531%2065.2121%2028.0363%2065.1184%2028.1068%2065.1059C28.1115%2065.1041%2028.1225%2065.1047%2028.1272%2065.1029Z%22%20fill%3D%22%23FFBF19%22%2F%3E%3Cpath%20d%3D%22M24.1272%2035.1049C24.16%2035.0922%2024.1831%2035.0684%2024.1919%2035.0354C24.2272%2034.9181%2024.3034%2034.5796%2024.1773%2033.8788C24.6794%2033.5757%2024.8335%2033.3268%2024.8932%2033.2445C24.9176%2033.2104%2024.9184%2033.1706%2024.8957%2033.1399C24.8601%2033.0896%2024.8429%2032.8994%2023.8661%2033.0756C23.1203%2031.9292%2022.9872%2032.079%2022.9213%2032.0897C22.9166%2032.0915%2022.9073%2032.0951%2022.9026%2032.097C22.8698%2032.1097%2022.8467%2032.1334%2022.8379%2032.1664C22.8012%2032.2941%2022.7489%2032.67%2022.8908%2033.4535C22.0581%2033.9734%2022.17%2034.1269%2022.1823%2034.1863C22.1862%2034.2242%2022.2135%2034.2531%2022.2546%2034.2618C22.3542%2034.2824%2022.5946%2034.3156%2023.1792%2034.1977C23.8531%2035.2141%2024.0363%2035.1204%2024.1068%2035.1078C24.1115%2035.106%2024.1225%2035.1067%2024.1272%2035.1049Z%22%20fill%3D%22%239BEC7D%22%2F%3E%3Cpath%20d%3D%22M15.0937%2054.5618L14.5682%2055.7761L17.7171%2056.8229L18.2426%2055.6086L15.0937%2054.5618Z%22%20fill%3D%22%23FF623A%22%2F%3E%3Cpath%20d%3D%22M96.078%2032.6055C96.0647%2032.6548%2096.0739%2032.7102%2096.1097%2032.7569C96.2279%2032.9107%2096.7718%2033.2274%2097.7795%2033.7279C97.6907%2034.6456%2097.6758%2035.1653%2097.7268%2035.3167C97.7496%2035.3757%2097.7971%2035.4151%2097.8539%2035.4199C97.9495%2035.4246%2098.0645%2035.4293%2098.745%2034.0266C100.897%2034.1494%20100.974%2033.9904%20101.023%2033.8979C101.026%2033.8881%20101.033%2033.8794%20101.037%2033.8646C101.05%2033.8153%20101.041%2033.7599%20101.005%2033.7132C100.881%2033.5472%20100.247%2033.1851%2099.1216%2032.6367C99.2398%2031.0922%2099.1382%2031.0382%2099.0533%2030.994C99.0031%2030.9645%2098.9423%2030.9745%2098.8915%2031.0189C98.771%2031.1239%2098.5201%2031.5849%2098.1308%2032.4317C96.2142%2032.3356%2096.1425%2032.4749%2096.0964%2032.5735C96.0879%2032.587%2096.0807%2032.5957%2096.078%2032.6055Z%22%20fill%3D%22%239D4492%22%2F%3E%3Cpath%20d%3D%22M126.156%2049.8145C126.143%2049.8638%20126.152%2049.9192%20126.188%2049.9659C126.306%2050.1196%20126.85%2050.4363%20127.858%2050.9369C127.769%2051.8546%20127.754%2052.3743%20127.805%2052.5257C127.828%2052.5847%20127.875%2052.624%20127.932%2052.6289C128.028%2052.6336%20128.143%2052.6383%20128.823%2051.2356C130.975%2051.3584%20131.052%2051.1994%20131.101%2051.1069C131.104%2051.097%20131.111%2051.0884%20131.115%2051.0736C131.128%2051.0243%20131.119%2050.9689%20131.083%2050.9222C130.959%2050.7562%20130.325%2050.3941%20129.2%2049.8457C129.318%2048.3012%20129.216%2048.2472%20129.131%2048.203C129.081%2048.1735%20129.02%2048.1835%20128.97%2048.2279C128.849%2048.3328%20128.598%2048.7939%20128.209%2049.6407C126.292%2049.5445%20126.221%2049.6838%20126.175%2049.7824C126.166%2049.796%20126.159%2049.8046%20126.156%2049.8145Z%22%20fill%3D%22%23A7EE8D%22%2F%3E%3Cpath%20d%3D%22M120.338%2059.8887L121.794%2058.9664L119.823%2055.1516L118.367%2056.0739L120.338%2059.8887Z%22%20fill%3D%22%239BEC7D%22%2F%3E%3Cpath%20d%3D%22M117.531%2036.5586L116.343%2037.3991L118.15%2040.4974L119.339%2039.6569L117.531%2036.5586Z%22%20fill%3D%22%23FFBF19%22%2F%3E%3Cpath%20d%3D%22M80.6419%2025.9833L80.3163%2024.539L76.9483%2025.5732L77.2738%2027.0175L80.6419%2025.9833Z%22%20fill%3D%22%23FFBF19%22%2F%3E%3Cpath%20d%3D%22M109.829%2048.4349L108.749%2047.1323L105.618%2050.1823L106.698%2051.4849L109.829%2048.4349Z%22%20fill%3D%22%239D4492%22%2F%3E%3Cpath%20d%3D%22M66.7549%2020.4988L66.2797%2018.8115L62.3243%2020.2783L62.7995%2021.9656L66.7549%2020.4988Z%22%20fill%3D%22%239D4492%22%2F%3E%3Cpath%20d%3D%22M104.749%2024.9248L105.677%2026.3595L109.097%2023.7033L108.169%2022.2685L104.749%2024.9248Z%22%20fill%3D%22%239BEC7D%22%2F%3E%3Cpath%20d%3D%22M115.977%2091.7592C115.968%2091.7937%20115.973%2091.827%20115.995%2091.854C116.07%2091.9536%20116.301%2092.2199%20116.951%2092.5389C116.897%2093.1326%20117.008%2093.4088%20117.039%2093.5072C117.052%2093.5478%20117.084%2093.5724%20117.123%2093.5723C117.186%2093.5734%20117.352%2093.6739%20117.796%2092.7679C119.184%2092.8478%20119.142%2092.6486%20119.173%2092.5882C119.174%2092.5832%20119.177%2092.5734%20119.178%2092.5685C119.187%2092.534%20119.182%2092.5007%20119.16%2092.4737C119.078%2092.3667%20118.801%2092.0974%20118.074%2091.7416C118.15%2090.7464%20117.957%2090.7457%20117.901%2090.7199C117.868%2090.7003%20117.827%2090.7053%20117.796%2090.7336C117.719%2090.8028%20117.547%2090.9797%20117.291%2091.5294C116.053%2091.4689%20116.019%2091.6754%20115.987%2091.7407C115.986%2091.7457%20115.978%2091.7543%20115.977%2091.7592Z%22%20fill%3D%22%239BEC7D%22%2F%3E%3Cpath%20d%3D%22M127.489%2078.9367L126.811%2077.7749L124.057%2079.7229L124.735%2080.8847L127.489%2078.9367Z%22%20fill%3D%22%23FF623A%22%2F%3E%3Ccircle%20cx%3D%2273.5%22%20cy%3D%2264.7305%22%20r%3D%2227.5%22%20fill%3D%22%230E9F6E%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M68.5539%2071.8815C68.8439%2072.1793%2069.3223%2072.1793%2069.6122%2071.8815L84.2185%2056.8765C84.9214%2056.1545%2086.0815%2056.1545%2086.7843%2056.8765C87.461%2057.5716%2087.461%2058.6791%2086.7843%2059.3742L70.0456%2076.5698C69.5183%2077.1115%2068.6479%2077.1115%2068.1206%2076.5698L60.2157%2068.4491C59.539%2067.754%2059.539%2066.6465%2060.2157%2065.9515C60.9185%2065.2294%2062.0786%2065.2294%2062.7815%2065.9515L68.5539%2071.8815Z%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E";

var Expand = "data:image/svg+xml,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M12.0991%2015.6785C11.694%2016.1072%2011.0119%2016.1072%2010.6068%2015.6785L4.98828%209.73136C4.36988%209.0768%204.83393%208%205.73441%208L16.9715%208C17.872%208%2018.336%209.0768%2017.7176%209.73136L12.0991%2015.6785Z%22%20fill%3D%22%23B7B8BD%22%2F%3E%3C%2Fsvg%3E";

var ExpandLight = "data:image/svg+xml,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M12.0991%2015.6785C11.694%2016.1072%2011.0119%2016.1072%2010.6068%2015.6785L4.98828%209.73136C4.36988%209.0768%204.83393%208%205.73441%208L16.9715%208C17.872%208%2018.336%209.0768%2017.7176%209.73136L12.0991%2015.6785Z%22%20fill%3D%22%23FFFFFF%22%2F%3E%3C%2Fsvg%3E";

var InfoCircle = "data:image/svg+xml,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%20%20%20%20%3Cpath%20d%3D%22M13%2016H12V12H11M12%208H12.01M21%2012C21%2013.1819%2020.7672%2014.3522%2020.3149%2015.4442C19.8626%2016.5361%2019.1997%2017.5282%2018.364%2018.364C17.5282%2019.1997%2016.5361%2019.8626%2015.4442%2020.3149C14.3522%2020.7672%2013.1819%2021%2012%2021C10.8181%2021%209.64778%2020.7672%208.55585%2020.3149C7.46392%2019.8626%206.47177%2019.1997%205.63604%2018.364C4.80031%2017.5282%204.13738%2016.5361%203.68508%2015.4442C3.23279%2014.3522%203%2013.1819%203%2012C3%209.61305%203.94821%207.32387%205.63604%205.63604C7.32387%203.94821%209.61305%203%2012%203C14.3869%203%2016.6761%203.94821%2018.364%205.63604C20.0518%207.32387%2021%209.61305%2021%2012Z%22%20stroke%3D%22%236B7280%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20%2F%3E%3C%2Fsvg%3E";

var InfoCircleLight = "data:image/svg+xml,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%20%20%20%20%3Cpath%20d%3D%22M13%2016H12V12H11M12%208H12.01M21%2012C21%2013.1819%2020.7672%2014.3522%2020.3149%2015.4442C19.8626%2016.5361%2019.1997%2017.5282%2018.364%2018.364C17.5282%2019.1997%2016.5361%2019.8626%2015.4442%2020.3149C14.3522%2020.7672%2013.1819%2021%2012%2021C10.8181%2021%209.64778%2020.7672%208.55585%2020.3149C7.46392%2019.8626%206.47177%2019.1997%205.63604%2018.364C4.80031%2017.5282%204.13738%2016.5361%203.68508%2015.4442C3.23279%2014.3522%203%2013.1819%203%2012C3%209.61305%203.94821%207.32387%205.63604%205.63604C7.32387%203.94821%209.61305%203%2012%203C14.3869%203%2016.6761%203.94821%2018.364%205.63604C20.0518%207.32387%2021%209.61305%2021%2012Z%22%20stroke%3D%22%239CA3AF%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20%2F%3E%3C%2Fsvg%3E";

const icons = {
  "arrow-left": {
    image: CircleArrowLeft
  },
  close: {
    image: Close
  },
  "expand-light": {
    image: ExpandLight
  },
  expand: {
    image: Expand
  },
  connected: {
    image: Connected
  },
  "information-circle-light": {
    image: InfoCircleLight
  },
  "information-circle": {
    image: InfoCircle
  }
};
function Icon(props) {
  const {
    iconName,
    iconTitle = "",
    height = "auto",
    width = "auto"
  } = props;
  return icons[iconName] ? /*#__PURE__*/jsx("img", {
    className: iconTitle ? "cursor-pointer" : "",
    height: height,
    width: width,
    src: icons[iconName].image,
    alt: iconName,
    title: iconTitle
  }) : null;
}

function Image$1(props) {
  const {
    hoverImageId,
    imageId,
    isButton = false,
    height = "auto",
    width = "auto"
  } = props;
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("img", {
      src: `https://images.web3auth.io/${imageId}.svg`,
      height: height,
      width: width,
      alt: imageId,
      className: "image-icon"
    }), isButton ? /*#__PURE__*/jsx("img", {
      src: `https://images.web3auth.io/${hoverImageId}.svg`,
      height: height,
      width: width,
      alt: hoverImageId,
      className: "hover-icon"
    }) : null]
  });
}

const closeIcon$1 = /*#__PURE__*/jsx(Icon, {
  iconName: "close"
});
function DetailedLoader(props) {
  const {
    adapter,
    appLogo,
    message,
    modalStatus,
    adapterName,
    onClose
  } = props;
  const web3authIcon = /*#__PURE__*/jsx(Image$1, {
    imageId: "web3auth"
  });
  const providerIcon = /*#__PURE__*/jsx(Image$1, {
    imageId: `login-${adapter}`
  });
  const [t] = useTranslation(undefined, {
    i18n: i18nInstance
  });
  const isDefaultLogo = [DEFAULT_LOGO_DARK, DEFAULT_LOGO_LIGHT].includes(appLogo);
  useEffect(() => {
    log.debug("adapter loader re-rendering");
    if (modalStatus === MODAL_STATUS.CONNECTED) {
      setTimeout(() => {
        onClose();
      }, 3000);
    }
  }, [modalStatus, onClose]);
  return modalStatus !== MODAL_STATUS.INITIALIZED ? /*#__PURE__*/jsxs("div", {
    className: "w3ajs-modal-loader w3a-modal__loader",
    children: [/*#__PURE__*/jsxs("div", {
      className: "w3a-modal__loader-content",
      children: [/*#__PURE__*/jsxs("div", {
        className: "w3a-modal__loader-info",
        children: [modalStatus === MODAL_STATUS.CONNECTING && /*#__PURE__*/jsxs(Fragment, {
          children: [/*#__PURE__*/jsxs("div", {
            className: "w3a-modal__loader-bridge",
            children: [/*#__PURE__*/jsx("div", {
              className: ["w3a-modal__loader-app-logo", isDefaultLogo ? "w3a-modal__loader-app-logo--default" : ""].join(" "),
              children: /*#__PURE__*/jsx("img", {
                src: appLogo,
                alt: ""
              })
            }), /*#__PURE__*/jsx("div", {
              className: "w3a-modal__connector",
              children: /*#__PURE__*/jsxs("div", {
                className: "w3a-modal__connector-beat",
                children: [/*#__PURE__*/jsx("div", {}), /*#__PURE__*/jsx("div", {}), /*#__PURE__*/jsx("div", {}), /*#__PURE__*/jsx("div", {}), /*#__PURE__*/jsx("div", {})]
              })
            }), /*#__PURE__*/jsx("div", {
              className: "w3a-modal__loader-social-logo",
              children: providerIcon
            })]
          }), /*#__PURE__*/jsxs("div", {
            children: [/*#__PURE__*/jsx("div", {
              className: "w3a-modal__loader-bridge-message",
              children: t("modal.adapter-loader.message1", {
                adapter: adapterName
              })
            }), /*#__PURE__*/jsx("div", {
              className: "w3a-modal__loader-bridge-message",
              children: t("modal.adapter-loader.message2", {
                adapter: adapterName
              })
            })]
          })]
        }), modalStatus === ADAPTER_STATUS.CONNECTED && /*#__PURE__*/jsxs("div", {
          className: "flex flex-col items-center",
          children: [/*#__PURE__*/jsx(Icon, {
            iconName: "connected"
          }), /*#__PURE__*/jsx("div", {
            className: "w3ajs-modal-loader__message w3a-spinner-message mt-4",
            children: message
          })]
        }), modalStatus === ADAPTER_STATUS.ERRORED && /*#__PURE__*/jsx("div", {
          className: "w3ajs-modal-loader__message w3a-spinner-message w3a-spinner-message--error",
          children: message
        })]
      }), /*#__PURE__*/jsxs("div", {
        className: "w3a-spinner-power",
        children: [/*#__PURE__*/jsx("div", {
          children: t("modal.footer.message")
        }), web3authIcon]
      })]
    }), (modalStatus === ADAPTER_STATUS.CONNECTED || modalStatus === ADAPTER_STATUS.ERRORED) && /*#__PURE__*/jsx("button", {
      type: "button",
      className: "w3a-header__button w3ajs-loader-close-btn",
      onClick: onClose,
      children: closeIcon$1
    })]
  }) : null;
}

const closeIcon = /*#__PURE__*/jsx(Icon, {
  iconName: "close"
});
function Loader(props) {
  const {
    message,
    modalStatus,
    label,
    onClose,
    canEmit = true
  } = props;
  const web3authIcon = /*#__PURE__*/jsx(Image$1, {
    imageId: "web3auth"
  });
  const [t] = useTranslation(undefined, {
    i18n: i18nInstance
  });
  useEffect(() => {
    log.debug("loader re-rendering");
    if (modalStatus === MODAL_STATUS.CONNECTED && canEmit) {
      setTimeout(() => {
        onClose();
      }, 3000);
    }
  }, [canEmit, modalStatus, onClose]);
  return modalStatus !== MODAL_STATUS.INITIALIZED ? /*#__PURE__*/jsxs("div", {
    className: "w3ajs-modal-loader w3a-modal__loader",
    children: [/*#__PURE__*/jsxs("div", {
      className: "w3a-modal__loader-content",
      children: [/*#__PURE__*/jsxs("div", {
        className: "w3a-modal__loader-info",
        children: [modalStatus === MODAL_STATUS.CONNECTING && /*#__PURE__*/jsxs("div", {
          className: "w3ajs-modal-loader__spinner w3a-spinner",
          children: [/*#__PURE__*/jsx("div", {
            className: "w3a-spinner__head"
          }), /*#__PURE__*/jsx("div", {
            className: "w3a-spinner__mask"
          })]
        }), /*#__PURE__*/jsx("div", {
          className: "w3ajs-modal-loader__label w3a-spinner-label",
          children: label
        }), modalStatus === ADAPTER_STATUS.CONNECTED && /*#__PURE__*/jsx("div", {
          className: "w3ajs-modal-loader__message w3a-spinner-message",
          children: message
        }), modalStatus === ADAPTER_STATUS.ERRORED && /*#__PURE__*/jsx("div", {
          className: "w3ajs-modal-loader__message w3a-spinner-message w3a-spinner-message--error",
          children: message
        })]
      }), /*#__PURE__*/jsxs("div", {
        className: "w3a-spinner-power",
        children: [/*#__PURE__*/jsx("div", {
          children: t("modal.footer.message")
        }), web3authIcon]
      })]
    }), (modalStatus === ADAPTER_STATUS.CONNECTED || modalStatus === ADAPTER_STATUS.ERRORED) && /*#__PURE__*/jsx("button", {
      type: "button",
      className: "w3a-header__button w3ajs-loader-close-btn",
      onClick: onClose,
      children: closeIcon
    })]
  }) : null;
}

function WalletConnect(props) {
  const {
    walletConnectUri
  } = props;
  const [t] = useTranslation(undefined, {
    i18n: i18nInstance
  });

  // TODO: show only wcAdapters of current chain
  return /*#__PURE__*/jsx("div", {
    className: "w3ajs-wallet-connect w3a-wallet-connect",
    children: /*#__PURE__*/jsx("div", {
      className: "w3ajs-wallet-connect__container w3a-wallet-connect__container",
      children: /*#__PURE__*/jsxs("div", {
        className: "w3a-wallet-connect__container-desktop",
        children: [/*#__PURE__*/jsx("div", {
          children: t("modal.external.walletconnect-subtitle")
        }), /*#__PURE__*/jsx("div", {
          className: "w3ajs-wallet-connect-qr w3a-wallet-connect-qr",
          tabIndex: 0,
          role: "button",
          onClick: () => copyToClipboard(walletConnectUri),
          onKeyDown: () => copyToClipboard(walletConnectUri),
          children: /*#__PURE__*/jsx(QRCode, {
            size: 200,
            eyeRadius: 5,
            qrStyle: "dots",
            removeQrCodeBehindLogo: true,
            logoImage: WALLET_CONNECT_LOGO,
            value: walletConnectUri
          })
        }), /*#__PURE__*/jsx("div", {
          children: t("modal.external.walletconnect-copy")
        })]
      })
    })
  });
}
var WalletConnect$1 = /*#__PURE__*/memo(WalletConnect);

function formatIOSMobile(params) {
  const encodedUri = encodeURIComponent(params.uri);
  if (params.universalLink) {
    return `${params.universalLink}/wc?uri=${encodedUri}`;
  }
  if (params.deepLink) {
    return `${params.deepLink}${params.deepLink.endsWith(":") ? "//" : "/"}wc?uri=${encodedUri}`;
  }
  return "";
}
function formatMobileRegistryEntry(entry, walletConnectUri, os) {
  let platform = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "mobile";
  const universalLink = entry[platform].universal || "";
  const deepLink = entry[platform].native || "";
  return {
    name: entry.name || "",
    logo: entry.logo || "",
    universalLink,
    deepLink,
    href: os === bowser.OS_MAP.iOS ? formatIOSMobile({
      uri: walletConnectUri,
      universalLink,
      deepLink
    }) : walletConnectUri
  };
}
function formatMobileRegistry(registry, walletConnectUri, os) {
  let platform = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "mobile";
  return Object.values(registry).filter(entry => !!entry[platform].universal || !!entry[platform].native).map(entry => formatMobileRegistryEntry(entry, walletConnectUri, os, platform));
}
function ExternalWallet(props) {
  const {
    hideExternalWallets,
    handleExternalWalletClick,
    config = {},
    walletConnectUri,
    showBackButton,
    modalStatus,
    wcAdapters
  } = props;
  const [isLoaded, setIsLoaded] = useState(true);
  const [adapterVisibilityMap, setAdapterVisibilityMap] = useState({});
  const [externalButtons, setExternalButtons] = useState([]);
  const deviceType = useMemo(() => {
    const browser = bowser.getParser(window.navigator.userAgent);
    return browser.getPlatformType();
  }, []);
  const deviceDetails = useMemo(() => {
    const browser = bowser.getParser(window.navigator.userAgent);
    return {
      platform: browser.getPlatformType(),
      os: browser.getOSName()
    };
  }, []);
  const [t] = useTranslation(undefined, {
    i18n: i18nInstance
  });
  useEffect(() => {
    var _config$walletConnect;
    log.debug("loaded external wallets", config, walletConnectUri, deviceType);
    const walletConnectAdapterName = WALLET_ADAPTERS.WALLET_CONNECT_V2;
    const wcAvailable = (((_config$walletConnect = config[walletConnectAdapterName]) === null || _config$walletConnect === void 0 ? void 0 : _config$walletConnect.showOnModal) || false) !== false;
    if (wcAvailable && !walletConnectUri) {
      setIsLoaded(false);
      handleExternalWalletClick({
        adapter: walletConnectAdapterName
      });
    } else if (Object.keys(config).length > 0) {
      setIsLoaded(true);
    }
    const canShowMap = {};
    Object.keys(config).forEach(adapter => {
      const adapterConfig = config[adapter];
      if (!adapterConfig.showOnModal) {
        canShowMap[adapter] = false;
        return;
      }
      if (deviceType === "desktop" && adapterConfig.showOnDesktop) {
        canShowMap[adapter] = true;
        return;
      }
      if ((deviceType === "mobile" || deviceType === "tablet") && adapterConfig.showOnMobile) {
        canShowMap[adapter] = true;
        return;
      }
      canShowMap[adapter] = false;
    });
    setAdapterVisibilityMap(canShowMap);
  }, [config, handleExternalWalletClick, walletConnectUri, deviceType]);
  useEffect(() => {
    const buttons = [];
    // add wallet connect links
    if (deviceDetails.platform === bowser.PLATFORMS_MAP.mobile) {
      let mobileLinks = formatMobileRegistry(wcAdapters, walletConnectUri, deviceDetails.os, deviceDetails.platform);
      if (deviceDetails.os === bowser.OS_MAP.iOS) {
        var _window$ethereum;
        if ((_window$ethereum = window.ethereum) !== null && _window$ethereum !== void 0 && _window$ethereum.isMetaMask) {
          // if metamask, use the metamask adapter directly
          mobileLinks = mobileLinks.filter(x => x.name !== "MetaMask");
        }
        buttons.push(...mobileLinks.map(link => ({
          name: link.name,
          href: link.href,
          logo: link.logo,
          isLink: true,
          block: false
        })));
      } else if (mobileLinks.length > 0) {
        buttons.push({
          name: "WalletConnect",
          href: mobileLinks[0].href,
          logo: WALLET_CONNECT_LOGO,
          isLink: true,
          block: true
        });
      }
    }
    const adapterBtns = Object.keys(config).filter(adapter => ![WALLET_ADAPTERS.WALLET_CONNECT_V2].includes(adapter) && adapterVisibilityMap[adapter]).map(adapter => ({
      name: adapter,
      isLink: false,
      block: false
    }));
    if (adapterBtns.length === 1 && deviceDetails.os !== bowser.OS_MAP.iOS) adapterBtns[0].block = true;
    buttons.push(...adapterBtns);
    setExternalButtons(buttons);
  }, [wcAdapters, config, deviceDetails.os, deviceDetails.platform, walletConnectUri, adapterVisibilityMap]);
  return /*#__PURE__*/jsx("div", {
    className: "w3ajs-external-wallet w3a-group",
    children: /*#__PURE__*/jsxs("div", {
      className: "w3a-external-container w3ajs-external-container",
      children: [showBackButton && /*#__PURE__*/jsxs("button", {
        type: "button",
        className: "w3a-external-back w3ajs-external-back",
        onClick: () => hideExternalWallets(),
        children: [/*#__PURE__*/jsx(Icon, {
          iconName: "arrow-left"
        }), /*#__PURE__*/jsx("div", {
          className: "w3a-group__title",
          children: t("modal.external.back")
        })]
      }), !isLoaded && /*#__PURE__*/jsx(Loader, {
        modalStatus: MODAL_STATUS.CONNECTING,
        canEmit: false
      }), Object.keys(config).map(adapter => {
        if (walletConnectUri && deviceDetails.platform === bowser.PLATFORMS_MAP.desktop && [WALLET_ADAPTERS.WALLET_CONNECT_V2].includes(adapter)) {
          return /*#__PURE__*/jsx(WalletConnect$1, {
            walletConnectUri: walletConnectUri
          }, adapter);
        }
        return null;
      }), modalStatus === MODAL_STATUS.INITIALIZED && /*#__PURE__*/jsx("ul", {
        className: "w3a-adapter-list w3ajs-wallet-adapters",
        children: externalButtons.map(button => {
          var _config$button$name, _config$button$name2;
          const providerIcon = button.isLink ? /*#__PURE__*/jsx("img", {
            src: button.logo,
            height: "auto",
            width: "auto",
            alt: `login-${button.name}`
          }) : /*#__PURE__*/jsx(Image$1, {
            imageId: `login-${button.name}`,
            hoverImageId: `login-${button.name}`,
            isButton: true
          });
          const isBlock = externalButtons.length === 1 || button.block;
          const label = isBlock ? /*#__PURE__*/jsx("p", {
            className: "ml-2 text-left",
            children: ((_config$button$name = config[button.name]) === null || _config$button$name === void 0 ? void 0 : _config$button$name.label) || button.name
          }) : "";
          return /*#__PURE__*/jsx("li", {
            className: [`w3a-adapter-item`, isBlock ? "w3a-adapter-item--full" : "col-span-2"].join(" "),
            children: button.isLink ? /*#__PURE__*/jsx("a", {
              href: button.href,
              rel: "noopener noreferrer",
              target: "_blank",
              children: /*#__PURE__*/jsxs("button", {
                type: "button",
                className: "w-full w3a-button w3a-button--login",
                children: [providerIcon, label]
              })
            }, button.name) : /*#__PURE__*/jsxs("button", {
              type: "button",
              onClick: () => handleExternalWalletClick({
                adapter: button.name
              }),
              className: "w-full w3a-button w3a-button--login",
              title: ((_config$button$name2 = config[button.name]) === null || _config$button$name2 === void 0 ? void 0 : _config$button$name2.label) || button.name,
              children: [providerIcon, label]
            })
          }, button.name);
        })
      })]
    })
  });
}

function Footer(props) {
  const {
    privacyPolicy,
    tncLink,
    defaultLanguage = "en"
  } = props;
  const [t] = useTranslation(undefined, {
    i18n: i18nInstance
  });
  const getPrivacyUrl = useCallback(() => {
    return (privacyPolicy === null || privacyPolicy === void 0 ? void 0 : privacyPolicy[defaultLanguage]) || (privacyPolicy === null || privacyPolicy === void 0 ? void 0 : privacyPolicy.en) || "https://docs.web3auth.io/legal/privacy-policy";
  }, [privacyPolicy, defaultLanguage]);
  const getTncUrl = useCallback(() => {
    return (tncLink === null || tncLink === void 0 ? void 0 : tncLink[defaultLanguage]) || (tncLink === null || tncLink === void 0 ? void 0 : tncLink.en) || "https://docs.web3auth.io/legal/terms-and-conditions";
  }, [tncLink, defaultLanguage]);
  return /*#__PURE__*/jsx("div", {
    className: "w3a-modal__footer",
    children: /*#__PURE__*/jsx("div", {
      className: "w3a-footer",
      children: /*#__PURE__*/jsxs("div", {
        children: [/*#__PURE__*/jsx("div", {
          children: /*#__PURE__*/jsx("div", {
            children: t("modal.footer.message-new")
          })
        }), /*#__PURE__*/jsxs("div", {
          className: "w3a-footer__links",
          children: [/*#__PURE__*/jsx("a", {
            href: getTncUrl(),
            target: "_blank",
            rel: "noreferrer noopener",
            children: t("modal.footer.terms-service")
          }), /*#__PURE__*/jsx("span", {
            children: "|"
          }), /*#__PURE__*/jsx("a", {
            href: getPrivacyUrl(),
            target: "_blank",
            rel: "noreferrer noopener",
            children: t("modal.footer.policy")
          })]
        })]
      })
    })
  });
}
var Footer$1 = /*#__PURE__*/memo(Footer);

function Header(props) {
  const {
    isDark
  } = useContext(ThemedContext);
  const {
    onClose,
    appLogo,
    appName
  } = props;
  const [t] = useTranslation(undefined, {
    i18n: i18nInstance
  });
  const headerLogo = [DEFAULT_LOGO_DARK, DEFAULT_LOGO_LIGHT].includes(appLogo) ? "" : appLogo;
  return /*#__PURE__*/jsxs("div", {
    className: "w3a-modal__header",
    children: [/*#__PURE__*/jsx("div", {
      className: "w3a-header",
      children: /*#__PURE__*/jsxs("div", {
        children: [headerLogo && /*#__PURE__*/jsx("div", {
          className: "w3a-header__logo",
          children: /*#__PURE__*/jsx("img", {
            src: headerLogo,
            alt: ""
          })
        }), /*#__PURE__*/jsx("div", {
          className: "w3a-header__title",
          children: t("modal.header-title")
        }), /*#__PURE__*/jsxs("div", {
          className: "w3a-header__subtitle",
          children: [t("modal.header-subtitle-name", {
            appName
          }), /*#__PURE__*/jsxs("div", {
            className: "relative flex flex-col items-center group cursor-pointer",
            children: [/*#__PURE__*/jsx(Icon, {
              iconName: `information-circle${isDark ? "-light" : ""}`
            }), /*#__PURE__*/jsxs("div", {
              className: "absolute top-4 z-20 flex-col items-center hidden mb-5 group-hover:flex",
              children: [/*#__PURE__*/jsx("div", {
                className: "w-3 h-3 ml-[3px] -mb-2 rotate-45 bg-app-gray-50 dark:bg-app-gray-600"
              }), /*#__PURE__*/jsxs("div", {
                className: "relative -ml-[100px] p-4 w-[300px] text-xs leading-none text-white rounded-md bg-app-gray-50 dark:bg-app-gray-600 shadow-lg",
                children: [/*#__PURE__*/jsx("div", {
                  className: "text-xs font-medium mb-1 text-app-gray-900 dark:text-white",
                  children: t("modal.header-tooltip-title")
                }), /*#__PURE__*/jsx("div", {
                  className: "text-xs text-app-gray-400",
                  children: t("modal.header-tooltip-desc")
                })]
              })]
            })]
          })]
        })]
      })
    }), /*#__PURE__*/jsx("button", {
      type: "button",
      onClick: onClose,
      className: "w3a-header__button w3ajs-close-btn",
      children: /*#__PURE__*/jsx(Icon, {
        iconName: "close"
      })
    })]
  });
}
const memoizedHeader = /*#__PURE__*/memo(Header, (prevProps, nextProps) => {
  if (prevProps.appLogo !== nextProps.appLogo) {
    return true;
  }
  return false;
});
memoizedHeader.displayName = "Header";

const getAdapterSocialLogins = function (adapterName) {
  let loginMethodsConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const finalLoginMethodsConfig = {};
  if (adapterName === WALLET_ADAPTERS.OPENLOGIN) {
    OPENLOGIN_PROVIDERS.forEach(loginMethod => {
      const currentLoginMethodConfig = loginMethodsConfig[loginMethod] || {
        name: OPENLOGIN_PROVIDERS_NAMES[loginMethod],
        showOnMobile: true,
        showOnModal: true,
        showOnDesktop: true
      };
      finalLoginMethodsConfig[loginMethod] = _objectSpread({}, currentLoginMethodConfig);
    });
    log.debug("OpenLogin login method ui config", finalLoginMethodsConfig);
  } else {
    throw new Error(`${adapterName} is not a valid adapter`);
  }
  return finalLoginMethodsConfig;
};
async function validateImageUrl(url) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = url;
    if (img.complete) {
      resolve(true);
    } else {
      img.addEventListener("load", () => {
        resolve(true);
      });
      img.addEventListener("error", () => {
        reject();
      });
    }
  });
}
async function getNetworkIconId(ticker) {
  const fallbackId = "network-default";
  if (!ticker) return fallbackId;
  try {
    const url = `https://images.web3auth.io/network-${ticker.toLowerCase()}.svg`;
    const isValid = await validateImageUrl(url);
    if (isValid) {
      return `network-${ticker.toLowerCase()}`;
    }
    return fallbackId;
  } catch {
    return fallbackId;
  }
}
const passwordlessBackendUrl = "https://api-passwordless.web3auth.io";
const getUserCountry = async () => {
  try {
    const result = await get(`${passwordlessBackendUrl}/api/v3/user/location`);
    if (result && result.data.country) return {
      country: result.data.country,
      dialCode: result.data.dial_code
    };
    return null;
  } catch (error) {
    log.error("error getting user country", error);
    return null;
  }
};
const validatePhoneNumber = async phoneNumber => {
  try {
    const result = await post(`${passwordlessBackendUrl}/api/v3/phone_number/validate`, {
      phone_number: phoneNumber
    });
    if (result && result.success) return result.parsed_number;
    return false;
  } catch (error) {
    log.error("error validating phone number", error);
    if (error.status === 400) {
      return false;
    }
    // sending true because we don't want the user to be stuck on a flow
    // if there is an error with the api or something went wrong.
    return true;
  }
};
const languageMap = {
  en: "english",
  de: "german",
  ja: "japanese",
  ko: "korean",
  zh: "mandarin",
  es: "spanish",
  fr: "french",
  pt: "portuguese",
  nl: "dutch"
};
const getUserLanguage = defaultLanguage => {
  let userLanguage = defaultLanguage;
  if (!userLanguage) {
    const browserLanguage = typeof window !== "undefined" ? window.navigator.userLanguage || window.navigator.language || "en-US" : "en-US";
    userLanguage = browserLanguage.split("-")[0];
  }
  return Object.prototype.hasOwnProperty.call(languageMap, userLanguage) ? userLanguage : "en";
};

function SocialLoginPasswordless(props) {
  const {
    handleSocialLoginClick,
    adapter,
    isPrimaryBtn,
    isEmailVisible,
    isSmsVisible,
    primaryColor
  } = props;
  const {
    isDark
  } = useContext(ThemedContext);
  const [fieldValue, setFieldValue] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [isValidInput, setIsValidInput] = useState(null);
  const [t] = useTranslation(undefined, {
    i18n: i18nInstance
  });
  const handleFormSubmit = async e => {
    e.preventDefault();
    const value = fieldValue;
    const isEmailValid = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
    if (isEmailValid) {
      return handleSocialLoginClick({
        adapter,
        loginParams: {
          loginProvider: LOGIN_PROVIDER.EMAIL_PASSWORDLESS,
          login_hint: value,
          name: "Email"
        }
      });
    }
    const number = value.startsWith("+") ? value : `${countryCode}${value}`;
    const result = await validatePhoneNumber(number);
    if (result) {
      return handleSocialLoginClick({
        adapter,
        loginParams: {
          loginProvider: LOGIN_PROVIDER.SMS_PASSWORDLESS,
          login_hint: typeof result === "string" ? result : number,
          name: "Mobile"
        }
      });
    }
    setIsValidInput(false);
    return undefined;
  };
  useEffect(() => {
    const getLocation = async () => {
      const result = await getUserCountry();
      if (result && result.dialCode) {
        setCountryCode(result.dialCode);
      }
    };
    if (isSmsVisible) getLocation();
  }, [isSmsVisible]);
  const handleInputChange = e => {
    setFieldValue(e.target.value);
    if (isValidInput === false) setIsValidInput(null);
  };
  const title = useMemo(() => {
    if (isEmailVisible && isSmsVisible) return "modal.social.passwordless-title";
    if (isEmailVisible) return "modal.social.email";
    return "modal.social.phone";
  }, [isEmailVisible, isSmsVisible]);
  const placeholder = useMemo(() => {
    if (isEmailVisible && isSmsVisible) return "+(00)123456/name@example.com";
    if (isEmailVisible) return "name@example.com";
    return "+(00)123456";
  }, [isEmailVisible, isSmsVisible]);
  return /*#__PURE__*/jsxs("div", {
    className: "w3ajs-passwordless w3a-group w3a-group--passwordless",
    children: [/*#__PURE__*/jsxs("div", {
      className: "w3a-group__title",
      children: [t(title), isSmsVisible && /*#__PURE__*/jsxs("div", {
        className: "relative flex flex-col items-center cursor-pointer group",
        children: [/*#__PURE__*/jsx(Icon, {
          iconName: `information-circle${isDark ? "-light" : ""}`
        }), /*#__PURE__*/jsxs("div", {
          className: "absolute z-20 flex-col items-center hidden mb-5 top-4 group-hover:flex",
          children: [/*#__PURE__*/jsx("div", {
            className: "w-3 h-3 ml-[3px] -mb-2 rotate-45 bg-app-gray-50 dark:bg-app-gray-600"
          }), /*#__PURE__*/jsxs("div", {
            className: "relative p-4 w-[300px] text-xs leading-none text-white rounded-md bg-app-gray-50 dark:bg-app-gray-600 shadow-lg",
            children: [/*#__PURE__*/jsx("div", {
              className: "mb-1 text-xs font-medium text-app-gray-900 dark:text-white",
              children: t("modal.popup.phone-header")
            }), /*#__PURE__*/jsx("div", {
              className: "text-xs text-app-gray-400",
              children: t("modal.popup.phone-body")
            })]
          })]
        })]
      })]
    }), /*#__PURE__*/jsxs("form", {
      className: "w3ajs-passwordless-form",
      onSubmit: e => handleFormSubmit(e),
      children: [/*#__PURE__*/jsx("input", {
        className: "w-full mb-4 w3a-text-field",
        name: "passwordless-input",
        required: true,
        placeholder: `${t("modal.social.sms-placeholder-text")} ${placeholder}`,
        onFocus: e => e.target.placeholder = "",
        onBlur: e => e.target.placeholder = `${t("modal.social.sms-placeholder-text")} ${placeholder}`,
        onChange: e => handleInputChange(e)
      }), isValidInput === false && /*#__PURE__*/jsx("div", {
        className: "w3a-sms-field--error",
        children: t("modal.errors-invalid-number-email")
      }), /*#__PURE__*/jsx("button", {
        disabled: fieldValue === "",
        className: `w3a-button ${isPrimaryBtn ? "w3a-button--primary" : ""} w-full`,
        style: {
          backgroundColor: isPrimaryBtn ? primaryColor || "" : ""
        },
        type: "submit",
        children: t("modal.social.passwordless-cta")
      })]
    })]
  });
}

function SocialLogins(props) {
  const [canShowMore, setCanShowMore] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const {
    socialLoginsConfig = {
      loginMethods: {},
      loginMethodsOrder: [],
      adapter: "",
      uiConfig: {}
    },
    handleSocialLoginClick
  } = props;
  const {
    isDark
  } = useContext(ThemedContext);
  const [t] = useTranslation(undefined, {
    i18n: i18nInstance
  });

  // Too small a function to use `useCallback`
  const expandClickHandler = () => {
    setIsExpanded(!isExpanded);
  };
  useEffect(() => {
    const maxOptions = Object.keys(socialLoginsConfig.loginMethods).filter(loginMethodKey => {
      return socialLoginsConfig.loginMethods[loginMethodKey].showOnModal;
    });
    setCanShowMore(maxOptions.length > 4);
  }, [socialLoginsConfig.loginMethods]);
  const adapterListClass = classNames("w3a-adapter-list", "w3ajs-socials-adapters", !isExpanded ? " w3a-adapter-list--shrink" : "");
  const adapterButtonClass = classNames("w3a-button-expand", "w3ajs-button-expand", isExpanded ? "w3a-button--rotate" : "");
  const adapterExpandText = isExpanded ? t("modal.social.view-less") : t("modal.social.view-more");
  const loginMethodsCount = Object.keys(socialLoginsConfig.loginMethods).length + 1;
  const restrictedLoginMethods = [LOGIN_PROVIDER.WEBAUTHN, LOGIN_PROVIDER.JWT, LOGIN_PROVIDER.SMS_PASSWORDLESS, LOGIN_PROVIDER.EMAIL_PASSWORDLESS];
  return /*#__PURE__*/jsxs("div", {
    className: "w3ajs-social-logins w3a-group",
    children: [/*#__PURE__*/jsx("ul", {
      className: adapterListClass,
      children: Object.keys(socialLoginsConfig.loginMethods).map(method => {
        var _socialLoginsConfig$u, _socialLoginsConfig$u2, _socialLoginsConfig$u3;
        const name = capitalizeFirstLetter(socialLoginsConfig.loginMethods[method].name || method);
        const orderIndex = socialLoginsConfig.loginMethodsOrder.indexOf(method) + 1;
        const order = orderIndex || Object.keys(socialLoginsConfig.loginMethods).length + 1;
        const isMainOption = socialLoginsConfig.loginMethods[method].mainOption;
        const isPrimaryBtn = (socialLoginsConfig === null || socialLoginsConfig === void 0 || (_socialLoginsConfig$u = socialLoginsConfig.uiConfig) === null || _socialLoginsConfig$u === void 0 ? void 0 : _socialLoginsConfig$u.primaryButton) === "socialLogin" && order === 1;
        const primaryColor = (socialLoginsConfig === null || socialLoginsConfig === void 0 || (_socialLoginsConfig$u2 = socialLoginsConfig.uiConfig) === null || _socialLoginsConfig$u2 === void 0 || (_socialLoginsConfig$u2 = _socialLoginsConfig$u2.theme) === null || _socialLoginsConfig$u2 === void 0 ? void 0 : _socialLoginsConfig$u2.primary) || "";
        const imageId = `login-${method}${isDark || isPrimaryBtn ? "-light" : "-dark"}`;
        const hoverId = `login-${method}-active`;
        const hoverImage = method === LOGIN_PROVIDER.APPLE || method === LOGIN_PROVIDER.GITHUB ? imageId : hoverId;
        const providerIcon = /*#__PURE__*/jsx(Image$1, {
          width: "20",
          imageId: imageId,
          hoverImageId: hoverImage,
          isButton: true
        });
        if (socialLoginsConfig.loginMethods[method].showOnModal === false || restrictedLoginMethods.includes(method)) {
          return null;
        }
        const loginMethodSpan = classNames("w3a-adapter-item", (socialLoginsConfig === null || socialLoginsConfig === void 0 || (_socialLoginsConfig$u3 = socialLoginsConfig.uiConfig) === null || _socialLoginsConfig$u3 === void 0 ? void 0 : _socialLoginsConfig$u3.loginGridCol) === 2 ? "col-span-3" : "col-span-2");
        if (isMainOption || order === 1) {
          return /*#__PURE__*/jsx("li", {
            className: "col-span-6 w3a-adapter-item",
            style: {
              order
            },
            children: /*#__PURE__*/jsxs("button", {
              type: "button",
              onClick: () => handleSocialLoginClick({
                adapter: socialLoginsConfig.adapter,
                loginParams: {
                  loginProvider: method,
                  name,
                  login_hint: ""
                }
              }),
              className: `w3a-button ${isPrimaryBtn ? "w3a-button--primary" : ""} w3a-button--login h-12 w-full`,
              style: {
                backgroundColor: isPrimaryBtn ? primaryColor : ""
              },
              title: name,
              children: [providerIcon, /*#__PURE__*/jsx("p", {
                className: "ml-2",
                children: t("modal.social.continueCustom", {
                  adapter: name
                })
              })]
            })
          }, method);
        }
        return /*#__PURE__*/jsx("li", {
          className: loginMethodSpan,
          style: {
            order: order + loginMethodsCount
          },
          children: /*#__PURE__*/jsx("button", {
            type: "button",
            onClick: () => handleSocialLoginClick({
              adapter: socialLoginsConfig.adapter,
              loginParams: {
                loginProvider: method,
                name,
                login_hint: ""
              }
            }),
            className: "w-full w3a-button w3a-button--login",
            title: name,
            children: providerIcon
          })
        }, method);
      })
    }), /*#__PURE__*/jsx("div", {
      className: "w3a-social__policy",
      children: t("modal.social.policy")
    }), canShowMore && /*#__PURE__*/jsx("div", {
      className: "text-right",
      children: /*#__PURE__*/jsx("button", {
        type: "button",
        className: adapterButtonClass,
        onClick: expandClickHandler,
        children: /*#__PURE__*/jsx("span", {
          className: "w3ajs-button-expand-text",
          children: adapterExpandText
        })
      })
    })]
  });
}

log.enableAll();

// const DETAILED_ADAPTERS = [WALLET_ADAPTERS.PHANTOM, WALLET_ADAPTERS.METAMASK];

function Modal(props) {
  var _modalState$socialLog, _modalState$socialLog2, _whiteLabel$theme, _modalState$socialLog5, _modalState$socialLog7, _modalState$socialLog9, _modalState$socialLog10;
  const [modalTransitionClasses, setModalTransitionClasses] = useState(["w3a-modal__inner"]);
  const [modalState, setModalState] = useState({
    externalWalletsVisibility: false,
    status: MODAL_STATUS.INITIALIZED,
    hasExternalWallets: false,
    externalWalletsInitialized: false,
    modalVisibility: false,
    modalVisibilityDelayed: false,
    postLoadingMessage: "",
    walletConnectUri: "",
    socialLoginsConfig: {
      loginMethods: {},
      loginMethodsOrder: [],
      adapter: "",
      uiConfig: {}
    },
    externalWalletsConfig: {},
    detailedLoaderAdapter: "",
    detailedLoaderAdapterName: "",
    showExternalWalletsOnly: false,
    wcAdapters: []
  });
  const {
    isDark
  } = useContext(ThemedContext);
  const [t] = useTranslation(undefined, {
    i18n: i18nInstance
  });
  const {
    stateListener,
    appLogo,
    appName,
    handleSocialLoginClick,
    handleExternalWalletClick,
    handleShowExternalWallets,
    closeModal,
    whiteLabel
  } = props;
  useEffect(() => {
    stateListener.emit("MOUNTED");
    stateListener.on("STATE_UPDATED", newModalState => {
      log.debug("state updated", newModalState);
      setModalState(prevState => {
        const mergedState = cloneDeep(deepmerge(prevState, newModalState));
        return mergedState;
      });
    });
  }, [stateListener]);
  useEffect(() => {
    let timeOutId;
    if (modalState.modalVisibility) {
      setModalState(prevState => {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          modalVisibilityDelayed: modalState.modalVisibility
        });
      });
      timeOutId = window.setTimeout(() => {
        setModalTransitionClasses(["w3a-modal__inner", modalState.modalVisibility ? "w3a-modal__inner--active" : ""]);
        // hide external wallets, if modal is closing, so that it will show social login screen on reopen.
      }, 100);
    } else {
      setModalTransitionClasses(["w3a-modal__inner", modalState.modalVisibility ? "w3a-modal__inner--active" : ""]);
      // hide external wallets, if modal is closing, so that it will show social login screen on reopen.

      timeOutId = window.setTimeout(() => {
        setModalState(prevState => {
          return _objectSpread(_objectSpread({}, prevState), {}, {
            modalVisibilityDelayed: modalState.modalVisibility
          });
        });
      }, 250);
    }
    return () => {
      clearTimeout(timeOutId);
    };
  }, [modalState.modalVisibility]);
  const onCloseLoader = useCallback(() => {
    if (modalState.status === MODAL_STATUS.CONNECTED) {
      closeModal();
    }
    if (modalState.status === MODAL_STATUS.ERRORED) {
      setModalState(prevState => {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          modalVisibility: true,
          status: MODAL_STATUS.INITIALIZED
        });
      });
    }
  }, [closeModal, modalState.status]);
  const preHandleExternalWalletClick = useCallback(params => {
    const {
      adapter
    } = params;
    setModalState(prevState => {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        detailedLoaderAdapter: adapter,
        detailedLoaderAdapterName: ADAPTER_NAMES[adapter]
      });
    });
    handleExternalWalletClick(params);
  }, [handleExternalWalletClick]);
  const preHandleSocialWalletClick = params => {
    const {
      loginParams
    } = params;
    setModalState(prevState => {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        detailedLoaderAdapter: loginParams.loginProvider,
        detailedLoaderAdapterName: loginParams.name
      });
    });
    handleSocialLoginClick(params);
  };
  const isEmailPrimary = ((_modalState$socialLog = modalState.socialLoginsConfig) === null || _modalState$socialLog === void 0 || (_modalState$socialLog = _modalState$socialLog.uiConfig) === null || _modalState$socialLog === void 0 ? void 0 : _modalState$socialLog.primaryButton) === "emailLogin";
  const isExternalPrimary = ((_modalState$socialLog2 = modalState.socialLoginsConfig) === null || _modalState$socialLog2 === void 0 || (_modalState$socialLog2 = _modalState$socialLog2.uiConfig) === null || _modalState$socialLog2 === void 0 ? void 0 : _modalState$socialLog2.primaryButton) === "externalLogin";
  const primaryColor = (whiteLabel === null || whiteLabel === void 0 || (_whiteLabel$theme = whiteLabel.theme) === null || _whiteLabel$theme === void 0 ? void 0 : _whiteLabel$theme.primary) || "";
  const externalWalletButton = /*#__PURE__*/jsx("div", {
    className: "w3ajs-external-wallet w3a-group",
    children: /*#__PURE__*/jsxs("div", {
      className: "w3a-external-toggle w3ajs-external-toggle",
      children: [/*#__PURE__*/jsx("div", {
        className: "w3a-group__title",
        children: t("modal.external.title")
      }), /*#__PURE__*/jsx("button", {
        type: "button",
        className: `w3a-button ${isExternalPrimary ? "w3a-button--primary" : ""} w-full w3ajs-external-toggle__button`,
        style: {
          backgroundColor: isExternalPrimary ? primaryColor : ""
        },
        onClick: () => {
          handleShowExternalWallets(modalState.externalWalletsInitialized);
          setModalState(prevState => {
            return _objectSpread(_objectSpread({}, prevState), {}, {
              externalWalletsVisibility: true
            });
          });
        },
        children: t("modal.external.connect")
      })]
    })
  });
  const areSocialLoginsVisible = useMemo(() => {
    var _modalState$socialLog3, _modalState$socialLog4;
    if (modalState.showExternalWalletsOnly) return false;
    if (Object.keys(((_modalState$socialLog3 = modalState.socialLoginsConfig) === null || _modalState$socialLog3 === void 0 ? void 0 : _modalState$socialLog3.loginMethods) || {}).length === 0) return false;
    const isAnySocialLoginVisible = Object.entries(((_modalState$socialLog4 = modalState.socialLoginsConfig) === null || _modalState$socialLog4 === void 0 ? void 0 : _modalState$socialLog4.loginMethods) || {}).some(_ref => {
      let [k, v] = _ref;
      return k !== LOGIN_PROVIDER.EMAIL_PASSWORDLESS && v.showOnModal !== false;
    });
    if (isAnySocialLoginVisible) return true;
    return false;
  }, [modalState.showExternalWalletsOnly, (_modalState$socialLog5 = modalState.socialLoginsConfig) === null || _modalState$socialLog5 === void 0 ? void 0 : _modalState$socialLog5.loginMethods]);
  log.info("modal state", modalState, areSocialLoginsVisible);
  const isEmailPasswordlessLoginVisible = useMemo(() => {
    var _modalState$socialLog6;
    return (_modalState$socialLog6 = modalState.socialLoginsConfig) === null || _modalState$socialLog6 === void 0 || (_modalState$socialLog6 = _modalState$socialLog6.loginMethods[LOGIN_PROVIDER.EMAIL_PASSWORDLESS]) === null || _modalState$socialLog6 === void 0 ? void 0 : _modalState$socialLog6.showOnModal;
  }, [(_modalState$socialLog7 = modalState.socialLoginsConfig) === null || _modalState$socialLog7 === void 0 ? void 0 : _modalState$socialLog7.loginMethods]);
  const isSmsPasswordlessLoginVisible = useMemo(() => {
    var _modalState$socialLog8;
    return (_modalState$socialLog8 = modalState.socialLoginsConfig) === null || _modalState$socialLog8 === void 0 || (_modalState$socialLog8 = _modalState$socialLog8.loginMethods[LOGIN_PROVIDER.SMS_PASSWORDLESS]) === null || _modalState$socialLog8 === void 0 ? void 0 : _modalState$socialLog8.showOnModal;
  }, [(_modalState$socialLog9 = modalState.socialLoginsConfig) === null || _modalState$socialLog9 === void 0 ? void 0 : _modalState$socialLog9.loginMethods]);

  // const modalClassName = `w3a-modal ${isDark ? "" : " w3a-modal--light"}`;
  const modalClassName = `w3a-modal ${isDark ? "" : ""}`;
  return modalState.modalVisibilityDelayed && /*#__PURE__*/jsx("div", {
    id: "w3a-modal",
    className: modalClassName,
    children: /*#__PURE__*/jsxs("div", {
      className: modalTransitionClasses.join(" "),
      children: [/*#__PURE__*/jsx(memoizedHeader, {
        onClose: closeModal,
        appLogo: appLogo,
        appName: appName
      }), modalState.status !== MODAL_STATUS.INITIALIZED ? /*#__PURE__*/jsx("div", {
        className: "w3a-modal__content w3ajs-content",
        children: /*#__PURE__*/jsx(DetailedLoader, {
          onClose: onCloseLoader,
          appLogo: appLogo,
          modalStatus: modalState.status,
          message: t(modalState.postLoadingMessage),
          adapter: modalState.detailedLoaderAdapter,
          adapterName: modalState.detailedLoaderAdapterName
        })
      }) : /*#__PURE__*/jsx("div", {
        className: "w3a-modal__content w3ajs-content",
        children: (areSocialLoginsVisible || isEmailPasswordlessLoginVisible || isSmsPasswordlessLoginVisible) && !modalState.externalWalletsVisibility ? /*#__PURE__*/jsxs(Fragment, {
          children: [areSocialLoginsVisible ? /*#__PURE__*/jsx(SocialLogins, {
            handleSocialLoginClick: params => preHandleSocialWalletClick(params),
            socialLoginsConfig: modalState.socialLoginsConfig
          }) : null, (isEmailPasswordlessLoginVisible || isSmsPasswordlessLoginVisible) && /*#__PURE__*/jsx(SocialLoginPasswordless, {
            isEmailVisible: isEmailPasswordlessLoginVisible,
            isSmsVisible: isSmsPasswordlessLoginVisible,
            adapter: (_modalState$socialLog10 = modalState.socialLoginsConfig) === null || _modalState$socialLog10 === void 0 ? void 0 : _modalState$socialLog10.adapter,
            handleSocialLoginClick: params => preHandleSocialWalletClick(params),
            isPrimaryBtn: isEmailPrimary,
            primaryColor: primaryColor
          }), modalState.hasExternalWallets && externalWalletButton]
        }) : /*#__PURE__*/jsx(ExternalWallet, {
          modalStatus: modalState.status,
          showBackButton: areSocialLoginsVisible,
          handleExternalWalletClick: preHandleExternalWalletClick,
          walletConnectUri: modalState.walletConnectUri,
          wcAdapters: modalState.wcAdapters,
          config: modalState.externalWalletsConfig,
          hideExternalWallets: () => setModalState(prevState => {
            return _objectSpread(_objectSpread({}, prevState), {}, {
              externalWalletsVisibility: false
            });
          })
        })
      }), /*#__PURE__*/jsx(Footer$1, {
        privacyPolicy: whiteLabel === null || whiteLabel === void 0 ? void 0 : whiteLabel.privacyPolicy,
        tncLink: whiteLabel === null || whiteLabel === void 0 ? void 0 : whiteLabel.tncLink,
        defaultLanguage: whiteLabel.defaultLanguage
      })]
    })
  });
}

function createWrapper$1(parentZIndex) {
  const existingWrapper = document.getElementById("w3a-parent-container");
  if (existingWrapper) existingWrapper.remove();
  const parent = document.createElement("section");
  parent.classList.add("w3a-parent-container");
  parent.setAttribute("id", "w3a-parent-container");
  parent.style.zIndex = parentZIndex;
  parent.style.position = "relative";
  const wrapper = document.createElement("section");
  wrapper.setAttribute("id", "w3a-container");
  parent.appendChild(wrapper);
  document.body.appendChild(parent);
  return wrapper;
}
class LoginModal extends SafeEventEmitter {
  constructor(_uiConfig) {
    super();
    _defineProperty(this, "uiConfig", void 0);
    _defineProperty(this, "stateEmitter", void 0);
    _defineProperty(this, "initModal", async () => {
      const darkState = {
        isDark: this.isDark
      };
      const useLang = this.uiConfig.defaultLanguage || "en";
      // Load new language resource

      if (useLang === "de") {
        import('./german-4ae2ee33.js').then(messages => {
          i18nInstance.addResourceBundle(useLang, "translation", messages.default);
          return i18nInstance.changeLanguage(useLang);
        }).catch(error => {
          log.error(error);
        });
      } else if (useLang === "ja") {
        import('./japanese-e1a7a06c.js').then(messages => {
          i18nInstance.addResourceBundle(useLang, "translation", messages.default);
          return i18nInstance.changeLanguage(useLang);
        }).catch(error => {
          log.error(error);
        });
      } else if (useLang === "ko") {
        import('./korean-95658e12.js').then(messages => {
          i18nInstance.addResourceBundle(useLang, "translation", messages.default);
          return i18nInstance.changeLanguage(useLang);
        }).catch(error => {
          log.error(error);
        });
      } else if (useLang === "zh") {
        import('./mandarin-1e325876.js').then(messages => {
          i18nInstance.addResourceBundle(useLang, "translation", messages.default);
          return i18nInstance.changeLanguage(useLang);
        }).catch(error => {
          log.error(error);
        });
      } else if (useLang === "es") {
        import('./spanish-54ba83ea.js').then(messages => {
          i18nInstance.addResourceBundle(useLang, "translation", messages.default);
          return i18nInstance.changeLanguage(useLang);
        }).catch(error => {
          log.error(error);
        });
      } else if (useLang === "fr") {
        import('./french-3d857bc5.js').then(messages => {
          i18nInstance.addResourceBundle(useLang, "translation", messages.default);
          return i18nInstance.changeLanguage(useLang);
        }).catch(error => {
          log.error(error);
        });
      } else if (useLang === "pt") {
        import('./portuguese-c1293d6a.js').then(messages => {
          i18nInstance.addResourceBundle(useLang, "translation", messages.default);
          return i18nInstance.changeLanguage(useLang);
        }).catch(error => {
          log.error(error);
        });
      } else if (useLang === "nl") {
        import('./dutch-9a1ae5c2.js').then(messages => {
          i18nInstance.addResourceBundle(useLang, "translation", messages.default);
          return i18nInstance.changeLanguage(useLang);
        }).catch(error => {
          log.error(error);
        });
      }
      return new Promise(resolve => {
        this.stateEmitter.once("MOUNTED", () => {
          log.info("rendered");
          this.setState({
            status: MODAL_STATUS.INITIALIZED
          });
          return resolve();
        });
        const container = createWrapper$1(this.uiConfig.modalZIndex);
        if (darkState.isDark) {
          container.classList.add("dark");
        } else {
          container.classList.remove("dark");
        }
        const root = createRoot(container);
        root.render( /*#__PURE__*/jsx(ThemedContext.Provider, {
          value: darkState,
          children: /*#__PURE__*/jsx(Modal, {
            closeModal: this.closeModal,
            stateListener: this.stateEmitter,
            handleShowExternalWallets: this.handleShowExternalWallets,
            handleExternalWalletClick: this.handleExternalWalletClick,
            handleSocialLoginClick: this.handleSocialLoginClick,
            appLogo: darkState.isDark ? this.uiConfig.logoDark : this.uiConfig.logoLight,
            appName: this.uiConfig.appName,
            whiteLabel: this.uiConfig
          })
        }));
      });
    });
    _defineProperty(this, "addSocialLogins", (adapter, loginMethods, loginMethodsOrder, uiConfig) => {
      this.setState({
        socialLoginsConfig: {
          adapter,
          loginMethods,
          loginMethodsOrder,
          uiConfig
        }
      });
      log.info("addSocialLogins", adapter, loginMethods, loginMethodsOrder, uiConfig);
    });
    _defineProperty(this, "addWalletLogins", (externalWalletsConfig, options) => {
      this.setState({
        externalWalletsConfig,
        externalWalletsInitialized: true,
        showExternalWalletsOnly: !!(options !== null && options !== void 0 && options.showExternalWalletsOnly),
        externalWalletsVisibility: true
      });
    });
    _defineProperty(this, "open", () => {
      this.setState({
        modalVisibility: true
      });
      this.emit(LOGIN_MODAL_EVENTS.MODAL_VISIBILITY, true);
    });
    _defineProperty(this, "closeModal", () => {
      this.setState({
        modalVisibility: false,
        externalWalletsVisibility: false
      });
      this.emit(LOGIN_MODAL_EVENTS.MODAL_VISIBILITY, false);
    });
    _defineProperty(this, "initExternalWalletContainer", () => {
      this.setState({
        hasExternalWallets: true
      });
    });
    _defineProperty(this, "handleShowExternalWallets", status => {
      this.emit(LOGIN_MODAL_EVENTS.INIT_EXTERNAL_WALLETS, {
        externalWalletsInitialized: status
      });
    });
    _defineProperty(this, "handleExternalWalletClick", params => {
      log.info("external wallet clicked", params);
      const {
        adapter
      } = params;
      this.emit(LOGIN_MODAL_EVENTS.LOGIN, {
        adapter
      });
    });
    _defineProperty(this, "handleSocialLoginClick", params => {
      log.info("social login clicked", params);
      const {
        adapter,
        loginParams
      } = params;
      this.emit(LOGIN_MODAL_EVENTS.LOGIN, {
        adapter,
        loginParams: {
          loginProvider: loginParams.loginProvider,
          login_hint: loginParams.login_hint,
          name: loginParams.name
        }
      });
    });
    _defineProperty(this, "setState", newState => {
      this.stateEmitter.emit("STATE_UPDATED", newState);
    });
    _defineProperty(this, "updateWalletConnect", (walletConnectUri, wcAdapters) => {
      if (!walletConnectUri) return;
      this.setState({
        walletConnectUri,
        wcAdapters
      });
    });
    _defineProperty(this, "handleAdapterData", adapterData => {
      if (adapterData.adapterName === WALLET_ADAPTERS.WALLET_CONNECT_V2) {
        const walletConnectData = adapterData.data;
        this.updateWalletConnect(walletConnectData.uri, walletConnectData.extensionAdapters);
      }
    });
    _defineProperty(this, "subscribeCoreEvents", listener => {
      listener.on(ADAPTER_EVENTS.CONNECTING, data => {
        log.info("connecting with adapter", data);
        // don't show loader in case of wallet connect, because currently it listens for incoming for incoming
        // connections without any user interaction.
        if ((data === null || data === void 0 ? void 0 : data.adapter) !== WALLET_ADAPTERS.WALLET_CONNECT_V2) {
          // const provider = data?.loginProvider || "";

          this.setState({
            status: MODAL_STATUS.CONNECTING
          });
        }
      });
      listener.on(ADAPTER_EVENTS.CONNECTED, data => {
        log.debug("connected with adapter", data);
        // only show success if not being reconnected again.
        if (!data.reconnected) {
          this.setState({
            status: MODAL_STATUS.CONNECTED,
            modalVisibility: true,
            postLoadingMessage: "modal.post-loading.connected"
          });
        } else {
          this.setState({
            status: MODAL_STATUS.CONNECTED
          });
        }
      });
      listener.on(ADAPTER_EVENTS.ERRORED, error => {
        log.error("error", error, error.message);
        if (error.code === 5000) {
          if (this.uiConfig.displayErrorsOnModal) this.setState({
            modalVisibility: true,
            postLoadingMessage: error.message || "modal.post-loading.something-wrong",
            status: MODAL_STATUS.ERRORED
          });else this.setState({
            modalVisibility: false
          });
        } else {
          this.setState({
            modalVisibility: true,
            status: MODAL_STATUS.INITIALIZED
          });
        }
      });
      listener.on(ADAPTER_EVENTS.DISCONNECTED, () => {
        this.setState({
          status: MODAL_STATUS.INITIALIZED,
          externalWalletsVisibility: false
        });
        // this.toggleMessage("");
      });

      listener.on(ADAPTER_EVENTS.ADAPTER_DATA_UPDATED, adapterData => {
        this.handleAdapterData(adapterData);
      });
    });
    this.uiConfig = _uiConfig;
    if (!_uiConfig.logoDark) this.uiConfig.logoDark = DEFAULT_LOGO_DARK;
    if (!_uiConfig.logoLight) this.uiConfig.logoLight = DEFAULT_LOGO_LIGHT;
    if (!_uiConfig.mode) this.uiConfig.mode = "auto";
    if (!_uiConfig.modalZIndex) this.uiConfig.modalZIndex = "99998";
    if (typeof _uiConfig.displayErrorsOnModal === "undefined") this.uiConfig.displayErrorsOnModal = true;
    if (!_uiConfig.defaultLanguage) this.uiConfig.defaultLanguage = "en";
    if (!_uiConfig.appName) this.uiConfig.appName = "Web3Auth";
    if (!_uiConfig.loginGridCol) this.uiConfig.loginGridCol = 3;
    if (!_uiConfig.primaryButton) this.uiConfig.primaryButton = "socialLogin";
    if (!_uiConfig.defaultLanguage) this.uiConfig.defaultLanguage = getUserLanguage(_uiConfig.defaultLanguage);
    this.stateEmitter = new SafeEventEmitter();
    this.subscribeCoreEvents(this.uiConfig.adapterListener);
  }
  get isDark() {
    return this.uiConfig.mode === "dark" || this.uiConfig.mode === "auto" && window.matchMedia("(prefers-color-scheme: dark)").matches;
  }
}

var css_248z = "@font-face{font-family:Poppins;font-style:normal;font-weight:600;src:url(https://fonts.gstatic.com/s/poppins/v15/pxiByp8kv8JHgFVrLEj6Z11lFd2JQEl8qw.woff2) format(\"woff2\");unicode-range:u+0900-097f,u+1cd0-1cf6,u+1cf8-1cf9,u+200c-200d,u+20a8,u+20b9,u+25cc,u+a830-a839,u+a8e0-a8fb}@font-face{font-family:Poppins;font-style:normal;font-weight:600;src:url(https://fonts.gstatic.com/s/poppins/v15/pxiByp8kv8JHgFVrLEj6Z1JlFd2JQEl8qw.woff2) format(\"woff2\");unicode-range:u+0100-024f,u+0259,u+1e??,u+2020,u+20a0-20ab,u+20ad-20cf,u+2113,u+2c60-2c7f,u+a720-a7ff}@font-face{font-family:Poppins;font-style:normal;font-weight:600;src:url(https://fonts.gstatic.com/s/poppins/v15/pxiByp8kv8JHgFVrLEj6Z1xlFd2JQEk.woff2) format(\"woff2\");unicode-range:u+00??,u+0131,u+0152-0153,u+02bb-02bc,u+02c6,u+02da,u+02dc,u+2000-206f,u+2074,u+20ac,u+2122,u+2191,u+2193,u+2212,u+2215,u+feff,u+fffd}@font-face{font-family:DM Sans;font-style:normal;font-weight:400;src:url(https://fonts.gstatic.com/s/dmsans/v6/rP2Hp2ywxg089UriCZ2IHTWEBlwu8Q.woff2) format(\"woff2\");unicode-range:u+0100-024f,u+0259,u+1e??,u+2020,u+20a0-20ab,u+20ad-20cf,u+2113,u+2c60-2c7f,u+a720-a7ff}@font-face{font-family:DM Sans;font-style:normal;font-weight:400;src:url(https://fonts.gstatic.com/s/dmsans/v6/rP2Hp2ywxg089UriCZOIHTWEBlw.woff2) format(\"woff2\");unicode-range:u+00??,u+0131,u+0152-0153,u+02bb-02bc,u+02c6,u+02da,u+02dc,u+2000-206f,u+2074,u+20ac,u+2122,u+2191,u+2193,u+2212,u+2215,u+feff,u+fffd}.w3a-parent-container #w3a-network-modal{--bg1:#fff;--bg2:#f9f9fb;--text-color1:#a2a5b5;--text-color2:#5c6c7f;--text-header:\"Poppins\",Helvetica,sans-serif;--text-body:\"DM Sans\",Helvetica,sans-serif;background:#000;color:var(--text-color1);height:100vh;left:0;padding:15px;position:fixed;top:0;width:100vw}.w3a-parent-container #w3a-network-modal,.w3a-parent-container #w3a-network-modal button.w3a-button{align-items:center;box-sizing:border-box;display:flex;font-family:var(--text-body);justify-content:center}.w3a-parent-container #w3a-network-modal button.w3a-button{background-color:#fff;border:1px solid #f3f3f4;border-radius:24px;box-shadow:none;color:#b7b8bd;cursor:pointer;font-size:16px;font-style:normal;font-weight:400;height:48px;padding:8px;width:100%}.w3a-parent-container #w3a-network-modal .w3a-switch-network{align-items:center;background:#f9f9fb;border-radius:10px;box-sizing:border-box;display:flex;flex-direction:column;font-family:var(--text-body);padding:20px;width:375px}.w3a-parent-container #w3a-network-modal .w3a-switch-network__title{color:var(--text-color2);font-family:var(--text-header);font-size:20px;margin-bottom:16px;text-align:center}.w3a-parent-container #w3a-network-modal .w3a-switch-network__link{background-color:#fff;border-radius:12px;color:#b7b8bd;font-size:12px;height:24px;padding:4px 16px}.w3a-parent-container #w3a-network-modal .w3a-switch-network__connect{display:flex;margin:40px auto 0}.w3a-parent-container #w3a-network-modal .w3a-switch-network__connect>div{color:var(--text-color2);font-size:10px;text-align:center}.w3a-parent-container .w3a-switch-network__connect-divider{margin-top:20px}.w3a-parent-container #w3a-network-modal .w3a-switch-network__logo{align-items:center;background:#fff;border-radius:50%;box-shadow:2px 2px 12px #0364ff0d;display:flex;height:58px;justify-content:center;margin:0 auto 6px;width:58px}.w3a-parent-container #w3a-network-modal .w3a-switch-network__logo img{height:34px;width:34px}.w3a-parent-container #w3a-network-modal .w3a-switch-network__buttons{column-gap:16px;display:flex;margin-top:60px;width:100%}.w3a-parent-container #w3a-network-modal .w3a-button.w3a-button--primary{background-color:#0364ff;color:#fff}";
styleInject(css_248z);

function AddNetwork(props) {
  const {
    chainConfig,
    appOrigin,
    onAddNetwork,
    onCancelNetwork
  } = props;
  const [showModal, setShowModal] = useState(true);
  const [networkIconId, setNetworkIconId] = useState("network-default");
  const [t] = useTranslation(undefined, {
    i18n: i18nInstance
  });
  useEffect(() => {
    getNetworkIconId(chainConfig.ticker).then(id => {
      return setNetworkIconId(id);
    }).catch(() => {});
  }, [chainConfig.ticker]);
  return showModal && /*#__PURE__*/jsx("div", {
    id: "w3a-modal-network",
    children: /*#__PURE__*/jsxs("div", {
      className: "w3a-switch-network",
      children: [/*#__PURE__*/jsx("div", {
        className: "w3a-switch-network__title",
        children: t("modal.network.add-request")
      }), /*#__PURE__*/jsx("div", {
        children: /*#__PURE__*/jsx("a", {
          className: "w3a-switch-network__link",
          href: appOrigin,
          children: appOrigin
        })
      }), /*#__PURE__*/jsx("div", {
        className: "w3a-switch-network__connect",
        children: /*#__PURE__*/jsxs("div", {
          children: [/*#__PURE__*/jsx("div", {
            className: "w3a-switch-network__logo",
            children: /*#__PURE__*/jsx(Image$1, {
              imageId: networkIconId
            })
          }), /*#__PURE__*/jsx("div", {
            children: /*#__PURE__*/jsx("div", {
              children: chainConfig.displayName
            })
          })]
        })
      }), /*#__PURE__*/jsxs("div", {
        className: "w3a-switch-network__buttons",
        children: [/*#__PURE__*/jsx("button", {
          type: "button",
          className: "w3a-button",
          onClick: () => {
            setShowModal(false);
            onCancelNetwork();
          },
          children: t("modal.network.cancel")
        }), /*#__PURE__*/jsx("button", {
          type: "button",
          className: "w3a-button w3a-button--primary",
          onClick: () => {
            setShowModal(false);
            onAddNetwork(chainConfig.chainId);
          },
          children: t("modal.network.proceed")
        })]
      })]
    })
  });
}

function SwitchNetwork(props) {
  const {
    currentChainConfig,
    newChainConfig,
    appOrigin,
    onSwitchNetwork,
    onCancelNetwork
  } = props;
  const [showModal, setShowModal] = useState(true);
  const [fromNetworkIconId, setFromNetworkIconId] = useState("network-default");
  const [toNetworkIconId, setToNetworkIconId] = useState("network-default");
  const [t] = useTranslation(undefined, {
    i18n: i18nInstance
  });
  useEffect(() => {
    getNetworkIconId(currentChainConfig.ticker).then(id => {
      return setFromNetworkIconId(id);
    }).catch(() => {});
    getNetworkIconId(newChainConfig.ticker).then(id => {
      return setToNetworkIconId(id);
    }).catch(() => {});
  }, [currentChainConfig.chainId, currentChainConfig.ticker, newChainConfig.chainId, newChainConfig.ticker]);
  return showModal && /*#__PURE__*/jsx("div", {
    id: "w3a-modal-network",
    children: /*#__PURE__*/jsxs("div", {
      className: "w3a-switch-network",
      children: [/*#__PURE__*/jsx("div", {
        className: "w3a-switch-network__title",
        children: t("modal.network.switch-request")
      }), /*#__PURE__*/jsx("div", {
        children: /*#__PURE__*/jsx("a", {
          className: "w3a-switch-network__link",
          href: appOrigin,
          children: appOrigin
        })
      }), /*#__PURE__*/jsxs("div", {
        className: "w3a-switch-network__connect",
        children: [/*#__PURE__*/jsxs("div", {
          children: [/*#__PURE__*/jsx("div", {
            className: "w3a-switch-network__logo",
            children: /*#__PURE__*/jsx(Image$1, {
              imageId: fromNetworkIconId
            })
          }), /*#__PURE__*/jsxs("div", {
            children: [/*#__PURE__*/jsxs("div", {
              children: [t("modal.network.from"), ":"]
            }), /*#__PURE__*/jsx("div", {
              children: currentChainConfig.displayName
            })]
          })]
        }), /*#__PURE__*/jsx("div", {
          children: /*#__PURE__*/jsx("div", {
            className: "w3a-switch-network__connect-divider",
            children: /*#__PURE__*/jsx(Image$1, {
              imageId: "network-arrow"
            })
          })
        }), /*#__PURE__*/jsxs("div", {
          children: [/*#__PURE__*/jsx("div", {
            className: "w3a-switch-network__logo",
            children: /*#__PURE__*/jsx(Image$1, {
              imageId: toNetworkIconId
            })
          }), /*#__PURE__*/jsxs("div", {
            children: [/*#__PURE__*/jsxs("div", {
              children: [t("modal.network.to"), ":"]
            }), /*#__PURE__*/jsx("div", {
              children: newChainConfig.displayName
            })]
          })]
        })]
      }), /*#__PURE__*/jsxs("div", {
        className: "w3a-switch-network__buttons",
        children: [/*#__PURE__*/jsx("button", {
          type: "button",
          className: "w3a-button",
          onClick: () => {
            setShowModal(false);
            onCancelNetwork();
          },
          children: t("modal.network.cancel")
        }), /*#__PURE__*/jsx("button", {
          type: "button",
          className: "w3a-button w3a-button--primary",
          onClick: () => {
            setShowModal(false);
            onSwitchNetwork(currentChainConfig.chainId, newChainConfig.chainId);
          },
          children: t("modal.network.proceed")
        })]
      })]
    })
  });
}

/* eslint-disable class-methods-use-this */
function createWrapper(id) {
  const element = document.getElementById(id || "w3a-network-container");
  if (element) return element;
  const wrapper = document.createElement("section");
  wrapper.setAttribute("id", id || "w3a-network-container");
  document.body.appendChild(wrapper);
  return wrapper;
}
class NetworkSwitch extends BaseNetworkSwitch {
  async addNetwork(params) {
    const {
      chainConfig,
      appOrigin
    } = params;
    return new Promise((resolve, reject) => {
      const addNetworkCallback = () => {
        return resolve(true);
      };
      const cancelCallback = () => {
        return reject(new Error("User cancelled request for adding new network"));
      };
      const container = createWrapper("w3a-add-network-container");
      const networkRoot = createRoot(container);
      networkRoot.render( /*#__PURE__*/jsx(AddNetwork, {
        appOrigin: appOrigin,
        chainConfig: chainConfig,
        onAddNetwork: addNetworkCallback,
        onCancelNetwork: cancelCallback
      }));
    });
  }
  async switchNetwork(params) {
    const {
      currentChainConfig,
      appOrigin,
      newChainConfig
    } = params;
    return new Promise((resolve, reject) => {
      const switchNetworkCallback = () => {
        return resolve(true);
      };
      const cancelCallback = () => {
        return reject(new Error("User cancelled request for adding new network"));
      };
      const networkSwitchContainer = createWrapper("w3a-switch-network-container");
      const networkRoot = createRoot(networkSwitchContainer);
      networkRoot.render( /*#__PURE__*/jsx(SwitchNetwork, {
        appOrigin: appOrigin,
        currentChainConfig: currentChainConfig,
        newChainConfig: newChainConfig,
        onSwitchNetwork: switchNetworkCallback,
        onCancelNetwork: cancelCallback
      }));
    });
  }
  cancel() {}
}

export { DEFAULT_LOGO_DARK, DEFAULT_LOGO_LIGHT, LOGIN_MODAL_EVENTS, LoginModal, MODAL_STATUS, NetworkSwitch, OPENLOGIN_PROVIDERS, OPENLOGIN_PROVIDERS_NAMES, WALLET_CONNECT_LOGO, capitalizeFirstLetter, LoginModal as default, getAdapterSocialLogins, getNetworkIconId, getUserCountry, getUserLanguage, languageMap, passwordlessBackendUrl, validateImageUrl, validatePhoneNumber };
//# sourceMappingURL=index.js.map
